/**
 * COMMON_SERVICE_TYPE 为目前所有服务资料集合
 *{
 *  "value": "0",服务类型id
 *  "label": "VAT税号申请",服务类型
 *}
 * VAT_SERVICE_TYPE 为目前所有ost服务资料集合
 * {
 *   "serviceType": "0",  // 服务类型id
 *   "serverType": "0",   // 服务类型id
 *   "belongingToType":"VAT",
 *   "primaryService":"1",// 是否支持供应商
 *   "copyData": true,  // 是否支持资料复用
 *   "serverName": "VAT注册",
 *   "isRenewal": true,   // 是否续费
 *   "vatIncrement": 1,   // 是否是VAT增值服务
 *   "routersValue": string,   // 小贸服务资料后跳转路由
 *   "serverDetailName": "VAT注册申报",
 *   "include": 1 // 0 - vat   1 - epr  2 - rsp 7 - 检测认证 8 - 其他申请/补充资料 5 - 小贸 6-绿舟 99 - 全部
 *   "inAdmin": 1 // 是否只使用在后台
 *   "isMainService": 1 // 是否主服务
 * },
 *
 * */
import {getLabelText} from '../utils.js'
import GenerateEnum from '../generateEnum'

const COMMON_SERVICE_TYPE = new GenerateEnum({
    VAT_TAX_NUMBER_APPLICATION: {
        value: '0',
        label: getLabelText({key: 'remote.enumerate.vatTaxNumberApplicationLabel', text: 'VAT税号申请'}),
        serviceType: '0',
        serverType: '0',
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        primaryService: 1,
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.vatTaxNumberApplicationServerDetailName', text: 'VAT注册'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.vatTaxNumberApplicationServerDetailName',
            text: 'VAT注册申报'
        }),
        include: 0,
        isMainService: 1
    },
    VAT_TRANSFORM_DECLARATION: {
        value: '1',
        label: getLabelText({key: 'remote.enumerate.vatTransformDeclarationLabel', text: 'VAT转代理'}),
        serviceType: '1',
        serverType: '1',
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.vatTransformDeclarationLabel', text: 'VAT转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.vatTransformDeclarationLabel', text: 'VAT转代理'}),
        include: 0,
        isMainService: 1
    },
    VAT_TAX_NUMBER_DEREGISTER: {
        value: '2',
        label: getLabelText({key: 'remote.enumerate.vatTaxNumberDeregisterServerDetailName', text: 'VAT税号注销'}),
        serviceType: '2',
        serverType: '2',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.vatTaxNumberDeregisterServerDetailName', text: 'VAT税号注销'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.vatTaxNumberDeregisterServerDetailName',
            text: 'VAT税号注销'
        }),
        include: 0
    },
    TAX_NUMBER_RENEW: {
        value: '3',
        label: getLabelText({key: 'remote.enumerate.taxNumberRenewLabel', text: '税号续费'}),
        serviceType: '3',
        serverType: '3',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.taxNumberRenewServerDetailName', text: 'VAT授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.taxNumberRenewServerDetailName', text: 'VAT授权续费'}),
        include: 0
    },
    VAT_PATCH_DECLARATION: {
        value: '4',
        label: getLabelText({key: 'remote.enumerate.vatPatchDeclarationServerDetailName', text: 'VAT补申报'}),
        serviceType: '4',
        serverType: '4',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.vatPatchDeclarationServerDetailName', text: 'VAT补申报'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.vatPatchDeclarationServerDetailName',
            text: 'VAT补申报'
        }),
        include: 0
    },
    HAGUE_CERTIFICATION: {
        value: '5',
        label: getLabelText({key: 'remote.enumerate.hagueCertificationServerDetailName', text: '海牙认证'}),
        serviceType: '5',
        serverType: '5',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.hagueCertificationServerDetailName', text: '海牙认证'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.hagueCertificationServerDetailName', text: '海牙认证'}),
        include: 0
    },
    HAGUE_SHARE: {
        value: '68',
        label: getLabelText({key: 'remote.enumerate.hagueShareServerDetailName', text: '共享海牙认证'}),
        serviceType: '68',
        serverType: '68',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.VAT', text: 'VAT'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.hagueShareServerDetailName', text: '共享海牙认证'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.hagueShareServerDetailName', text: '共享海牙认证'}),
        include: 0
    },
    VAT_TRANSFORM_DECLARATION_WITH_HAGUE: {
        value: '6',
        label: getLabelText({
            key: 'remote.enumerate.vatTransformDeclarationWithHagueLabel',
            text: 'VAT转代理(含海牙认证)'
        }),
        serviceType: '6',
        serverType: '6',
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({
            key: 'remote.enumerate.vatTransformDeclarationWithHagueServerDetailName',
            text: 'VAT转代理(含海牙)'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.vatTransformDeclarationWithHagueServerDetailName',
            text: 'VAT转代理(含海牙)'
        }),
        include: 0,
        isMainService: 1
    },
    VAT_TRANSFORM_DECLARATION_WITHOUT_HAGUE: {
        value: '7',
        label: getLabelText({
            key: 'remote.enumerate.vatTransformDeclarationWithoutHagueLabel',
            text: 'VAT转代理(不含海牙认证)'
        }),
        serviceType: '7',
        serverType: '7',
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({
            key: 'remote.enumerate.vatTransformDeclarationWithoutHagueServerDetailName',
            text: 'VAT转代理(不含海牙)'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.vatTransformDeclarationWithoutHagueServerDetailName',
            text: 'VAT转代理(不含海牙)'
        }),
        include: 0,
        isMainService: 1
    },
    UK_TAX_APPLICATION: {
        value: '8',
        label: getLabelText({key: 'remote.enumerate.ukTaxApplicationServerDetailName', text: '标准税率申请'}),
        serviceType: '8',
        serverType: '8',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.ukTaxApplicationServerDetailName', text: '标准税率申请'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.ukTaxApplicationServerDetailName',
            text: '标准税率申请'
        }),
        include: 0
    },
    ZM_DECLARE: {
        value: '10',
        label: getLabelText({key: 'remote.enumerate.zmDeclareServerDetailName', text: 'ZM申报'}),
        serviceType: '10',
        serverType: '10',
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.zmDeclareServerDetailName', text: 'ZM申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.zmDeclareServerDetailName', text: 'ZM申报'}),
        include: 0
    },
    ZM_MAKE_UP_DECLARE: {
        value: '11',
        label: getLabelText({key: 'remote.enumerate.zmMakeUpDeclareServerDetailName', text: 'ZM补申报'}),
        serviceType: '11',
        serverType: '11',
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.zmMakeUpDeclareServerDetailName', text: 'ZM补申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.zmMakeUpDeclareServerDetailName', text: 'ZM补申报'}),
        include: 0
    },
    IOSS_REGISTRATION_DECLARATION: {
        value: '12',
        label: getLabelText({key: 'remote.enumerate.iossRegistrationDeclarationLabel', text: 'IOSS注册申报'}),
        serviceType: '12',
        serverType: '12',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeIoss', text: 'IOSS'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.iossRegistrationDeclarationLabel', text: 'IOSS注册申报'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.iossRegistrationDeclarationLabel',
            text: 'IOSS注册申报'
        }),
        include: 0,
        isMainService: 1
    },
    EORI_APPLICATION: {
        value: '13',
        label: getLabelText({key: 'remote.enumerate.eoriApplicationLabel', text: 'EORI申请'}),
        serviceType: '13',
        serverType: '13',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.eoriApplicationLabel', text: 'EORI申请'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.eoriApplicationLabel', text: 'EORI申请'}),
        include: 0
    },
    IOSS_TAX_NUMBER_RENEW: {
        value: '14',
        label: getLabelText({key: 'remote.enumerate.iossAuthorizationRenewalLabel', text: 'IOSS授权续费'}),
        serviceType: '14',
        serverType: '14',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeIoss', text: 'IOSS'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.iossAuthorizationRenewalLabel', text: 'IOSS授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.iossAuthorizationRenewalLabel', text: 'IOSS授权续费'}),
        include: 0
    },
    VAT_TAX_NUMBER_CHEMISTRY_APPLICATION: {
        value: '15',
        label: getLabelText({key: 'remote.enumerate.chemistryTaxRegistrationDeclarationLabel', text: '化学税注册申报'}),
        serviceType: '15',
        serverType: '15',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeChemicalTax', text: '化学税'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({
            key: 'remote.enumerate.chemistryTaxRegistrationDeclarationLabel',
            text: '化学税注册申报'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.chemistryTaxRegistrationDeclarationLabel',
            text: '化学税注册申报'
        }),
        include: 0,
        isMainService: 1
    },
    VAT_TRANSFORM_CHEMISTRY_DECLARATION: {
        value: '16',
        label: getLabelText({key: 'remote.enumerate.chemistryTaxTransferAgencyLabel', text: '化学税转代理'}),
        serviceType: '16',
        serverType: '16',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeChemicalTax', text: '化学税'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.chemistryTaxTransferAgencyLabel', text: '化学税转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.chemistryTaxTransferAgencyLabel', text: '化学税转代理'}),
        include: 0,
        isMainService: 1
    },
    JCT_REGISTER: {
        value: '17',
        label: getLabelText({key: 'remote.enumerate.jctRegistrationDeclarationLabel', text: 'JCT注册申报'}),
        serviceType: '17',
        serverType: '17',
        belongingToType: getLabelText({key: 'remote.enumerate.JCT', text: 'JCT'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.jctRegistrationDeclarationLabel', text: 'JCT注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.jctRegistrationDeclarationLabel', text: 'JCT注册申报'}),
        include: 0,
        isMainService: 1
    },
    JCT_TRANSFORM_DECLARATION: {
        value: '52',
        label: getLabelText({key: 'remote.enumerate.jctTransferAgencyLabel', text: 'JCT转代理'}),
        serviceType: '52',
        serverType: '52',
        belongingToType: getLabelText({key: 'remote.enumerate.JCT', text: 'JCT'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.jctTransferAgencyLabel', text: 'JCT转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.jctTransferAgencyLabel', text: 'JCT转代理'}),
        include: 0,
        isMainService: 1
    },
    JCT_RENEW: {
        value: '18',
        label: getLabelText({key: 'remote.enumerate.jctAuthorizationRenewalLabel', text: 'JCT授权续费'}),
        serviceType: '18',
        serverType: '18',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.JCT', text: 'JCT'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.jctAuthorizationRenewalLabel', text: 'JCT授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.jctAuthorizationRenewalLabel', text: 'JCT授权续费'}),
        include: 0
    },
    CHEMISTRY_TAX_RENEW: {
        value: '20',
        label: getLabelText({key: 'remote.enumerate.chemistryTaxAuthorizationRenewalLabel', text: '化学税授权续费'}),
        serviceType: '20',
        serverType: '20',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeChemicalTax', text: '化学税'}),
        isRenewal: true,
        serverName: getLabelText({
            key: 'remote.enumerate.chemistryTaxAuthorizationRenewalLabel',
            text: '化学税授权续费'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.chemistryTaxAuthorizationRenewalLabel',
            text: '化学税授权续费'
        }),
        include: 0
    },
    WEEE_REGISTRATION_DECLARATION: {
        value: '101',
        label: getLabelText({key: 'remote.enumerate.weeeRegistrationDeclarationLabel', text: 'WEEE注册申报'}),
        serviceType: '101',
        serverType: '101',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.weeeRegistrationDeclarationLabel',
            text: 'WEEE注册申报'
        }),
        include: 1,
        isMainService: 1
    },
    PACKAGING_REGISTRATION_DECLARATION: {
        value: '102',
        label: getLabelText({key: 'remote.enumerate.packagingLawRegistrationDeclarationLabel', text: '包装法注册申报'}),
        serviceType: '102',
        serverType: '102',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.packagingLawRegistrationDeclarationLabel',
            text: '包装法注册申报'
        }),
        include: 1,
        isMainService: 1
    },
    BATTERY_REGISTRATION_DECLARATION: {
        value: '103',
        label: getLabelText({key: 'remote.enumerate.batteryLawRegistrationDeclarationLabel', text: '电池法注册申报'}),
        serviceType: '103',
        serverType: '103',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.batteryLawRegistrationDeclarationLabel',
            text: '电池法注册申报'
        }),
        include: 1,
        isMainService: 1
    },
    EU_DELEGATE_AUTHORIZATION: {
        value: '104',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative', text: '授权代表'}),
        serviceType: '104',
        serverType: '104',
        primaryService: 1,
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative',
            text: '授权代表'
        }),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative', text: '授权代表'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative',
            text: '授权代表'
        }),
        include: 2,
        isMainService: 1
    },
    AUTHORIZATION_PLATFORM_VALIDATE: {
        value: '188',
        label: getLabelText({key: 'remote.enumerate.authorizationPlatformValidationLabel', text: '授权代表（平台验证）'}),
        serviceType: '188',
        serverType: '188',
        primaryService: 1,
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative',
            text: '授权代表（平台验证）'
        }),
        copyData: true,
        serverName: getLabelText({
            key: 'remote.enumerate.authorizationPlatformValidationLabel',
            text: '授权代表（平台验证）'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.authorizationPlatformValidationLabel',
            text: '授权代表（平台验证）'
        }),
        include: 2,
        isMainService: 1
    },
    AUTHORIZATION_ADD_PRODUCT: {
        value: '189',
        label: getLabelText({key: 'remote.enumerate.authorizationProductAdditionLabel', text: '授权代表追加'}),
        serviceType: '189',
        serverType: '189',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.authorizationProductAdditionLabel', text: '授权代表'}),
        copyData: false,
        serverName: getLabelText({key: 'remote.enumerate.authorizationProductAdditionLabel', text: '授权代表追加'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.authorizationProductAdditionLabel',
            text: '授权代表追加'
        }),
        include: 2
    },
    AUTHORIZATION_PRODUCT_GROUP: {
        value: '190',
        label: getLabelText({key: 'remote.enumerate.authorizationProductGroupLabel', text: '授权代表（产品组）'}),
        serviceType: '190',
        serverType: '190',
        primaryService: 1,
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative',
            text: '授权代表（产品组）'
        }),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.authorizationProductGroupLabel', text: '授权代表（产品组）'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.authorizationProductGroupLabel',
            text: '授权代表（产品组）'
        }),
        include: 2,
        isMainService: 1
    },
    AUTHORIZATION_PRODUCT_GROUP_ADD: {
        value: '191',
        label: getLabelText({
            key: 'remote.enumerate.authorizationProductAdditionalGroupLabel',
            text: '授权代表追加（产品组）'
        }),
        serviceType: '191',
        serverType: '191',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.authorizedRepresentative', text: '授权代表（产品组）'}),
        copyData: false,
        serverName: getLabelText({
            key: 'remote.enumerate.authorizationProductAdditionalGroupLabel',
            text: '授权代表追加（产品组）'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.authorizationProductAdditionalGroupLabel',
            text: '授权代表追加（产品组）'
        }),
        include: 2,
        isRenewal: true
    },
    AUTHORIZATION_PRODUCT_SERIES: {
        value: '192',
        label: getLabelText({key: 'remote.enumerate.authorizationProductSeriesLabel', text: '授权代表（产品系列）'}),
        serviceType: '192',
        serverType: '192',
        primaryService: 1,
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative',
            text: '授权代表（产品系列）'
        }),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.authorizationProductSeriesLabel', text: '授权代表（产品系列）'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.authorizationProductSeriesLabel',
            text: '授权代表（产品系列）'
        }),
        include: 2,
        isMainService: 1
    },
    AUTHORIZATION_PRODUCT_SERIES_ADD: {
        value: '193',
        label: getLabelText({
            key: 'remote.enumerate.authorizationProductAdditionalSeriesLabel',
            text: '授权代表追加（产品系列）'
        }),
        serviceType: '193',
        serverType: '193',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.authorizationProductSeriesLabel', text: '授权代表（产品系列）'}),
        copyData: false,
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.authorizationProductAdditionalSeriesLabel', text: '授权代表追加（产品系列）'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.authorizationProductAdditionalSeriesLabel',
            text: '授权代表追加（产品系列）'
        }),
        include: 2
    },
    AUTHORIZATION_PRODUCT_GROUP_RENEW: {
        value: '290',
        label: getLabelText({key: 'remote.enumerate.AuthorizedRenewalProductUser', text: '授权代表续费（产品组）'}),
        serviceType: '290',
        serverType: '290',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.authorizedRepresentative', text: '授权代表（产品组）'}),
        copyData: false,
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.AuthorizedRenewalProductUser', text: '授权代表续费（产品组）'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.AuthorizedRenewalProductUser',
            text: '授权代表续费（产品组）'
        }),
        include: 2
    },
    PACKAGING_TRANSFORM_DECLARATION: {
        value: '105',
        label: getLabelText({key: 'remote.enumerate.packagingTransformDeclaration', text: '包装法转代理'}),
        serviceType: '105',
        serverType: '105',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.packagingTransformDeclaration', text: '包装法转代理'}),
        include: 1,
        isMainService: 1
    },
    BATTERY_TRANSFORM_DECLARATION: {
        value: '126',
        label: getLabelText({key: 'remote.enumerate.batteryTransformDeclaration', text: '电池法转代理'}),
        serviceType: '126',
        serverType: '126',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.batteryTransformDeclaration', text: '电池法转代理'}),
        include: 1,
        isMainService: 1
    },
    WEEE_TRANSFORM_DECLARATION: {
        value: '127',
        label: getLabelText({key: 'remote.enumerate.weeeTransformDeclaration', text: 'WEEE转代理'}),
        serviceType: '127',
        serverType: '127',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.weeeTransformDeclaration', text: 'WEEE转代理'}),
        include: 1,
        isMainService: 1
    },
    TEXTILE_LAW_TRANSFORM_DECLARATION: {
        value: '128',
        label: getLabelText({key: 'remote.enumerate.textileLawTransformDeclaration', text: '纺织法转代理'}),
        serviceType: '128',
        serverType: '128',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTextileLaw', text: '纺织法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeTextileLaw', text: '纺织法'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.textileLawTransformDeclaration', text: '纺织法转代理'}),
        include: 1,
        isMainService: 1
    },
    EU_DELEGATE_AUTHORIZATION_RENEW: {
        value: '204',
        label: getLabelText({key: 'remote.enumerate.euDelegateAuthorizationRenew', text: '授权代表续费'}),
        serviceType: '204',
        serverType: '204',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative',
            text: '授权代表'
        }),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.euDelegateAuthorizationRenew', text: '授权代表续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.euDelegateAuthorizationRenew', text: '授权代表续费'}),
        include: 2
    },
    PACKAGING_RENEW: {
        value: '202',
        label: getLabelText({key: 'remote.enumerate.packagingRenew', text: '包装法续费'}),
        serviceType: '202',
        serverType: '202',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.packagingRenew', text: '包装法续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.packagingRenew', text: '包装法续费'}),
        include: 1
    },
    BATTERY_RENEW: {
        value: '203',
        label: getLabelText({key: 'remote.enumerate.batteryRenew', text: '电池法续费'}),
        serviceType: '203',
        serverType: '203',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.batteryRenew', text: '电池法续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.batteryRenew', text: '电池法续费'}),
        include: 1
    },
    WEEE_RENEW: {
        value: '201',
        label: getLabelText({key: 'remote.enumerate.weeeRenew', text: 'WEEE续费'}),
        serviceType: '201',
        serverType: '201',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.weeeRenew', text: 'WEEE续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.weeeRenew', text: 'WEEE续费'}),
        include: 1
    },
    CHANGE_TAX_NAM: {
        value: '21',
        label: getLabelText({key: 'remote.enumerate.changeTaxNam', text: '改税号名称'}),
        serviceType: '21',
        serverType: '21',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.taxNumberChange', text: '税号名称更改'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.taxNumberChange', text: '税号名称更改'}),
        include: 0
    },
    CHANGE_REPORT: {
        value: '22',
        label: getLabelText({key: 'remote.enumerate.changeReport', text: '更改申报'}),
        serviceType: '22',
        serverType: '22',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.changeReport', text: '更改申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.changeReport', text: '更改申报'}),
        include: 0
    },
    CHANGE_ADDRESS: {
        value: '23',
        label: getLabelText({key: 'remote.enumerate.changeAddress', text: '改地址'}),
        serviceType: '23',
        serverType: '23',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.changeAddress', text: '改地址'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.changeAddress', text: '改地址'}),
        include: 0
    },
    PHONE_EMIAL_QUERY_TAX: {
        value: '24',
        label: getLabelText({key: 'remote.enumerate.phoneEmialQueryTax', text: '电话/邮件协助查税处理'}),
        serviceType: '24',
        serverType: '24',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.phoneEmialQueryTax', text: '电话/邮件协助查税处理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.phoneEmialQueryTax', text: '电话/邮件协助查税处理'}),
        include: 0
    },
    ACTIVITY_TAX_VAT: {
        value: '25',
        label: getLabelText({key: 'remote.enumerate.activityTaxVat', text: '激活税号'}),
        serviceType: '25',
        serverType: '25',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.activityTaxVat', text: '激活税号'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.activityTaxVat', text: '激活税号'}),
        include: 0
    },
    claim_TAX_OR_RETRUN_TAX_HANDLE: {
        value: '26',
        label: getLabelText({key: 'remote.enumerate.claimTaxOrReturnTaxHandle', text: '认领税金/退税支票处理'}),
        serviceType: '26',
        serverType: '26',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.claimTaxOrReturnTaxHandle', text: '认领税金/退税支票处理'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.claimTaxOrReturnTaxHandle',
            text: '认领税金/退税支票处理'
        }),
        include: 0
    },
    HANDLE_FINE: {
        value: '27',
        label: getLabelText({key: 'remote.enumerate.handleFine', text: '处理罚单'}),
        serviceType: '27',
        serverType: '27',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.handleFine', text: '处理罚单'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.handleFine', text: '处理罚单'}),
        include: 0
    },
    REPLENISH_YEAR_DECLARE: {
        value: '28',
        label: getLabelText({key: 'remote.enumerate.replenishYearDeclare', text: '补年报'}),
        serviceType: '28',
        serverType: '28',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.replenishYearDeclare', text: '补年报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.replenishYearDeclare', text: '补年报'}),
        include: 0
    },
    CUSTOMIZE_SERVICE: {
        value: '29',
        label: getLabelText({key: 'remote.enumerate.customizeService', text: '自定义增值服务'}),
        serviceType: '29',
        serverType: '29',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.customizeService', text: '自定义增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.customizeService', text: '自定义增值服务'}),
        include: 1
    },
    ES_B2B_DECLARE: {
        value: '30',
        label: getLabelText({key: 'remote.enumerate.esB2bDeclare', text: 'B2B申报'}),
        serviceType: '30',
        serverType: '30',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.esB2bDeclare', text: 'B2B申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.esB2bDeclare', text: 'B2B申报'}),
        include: 0
    },
    HANDLE_MTD_ACCOUNT_PASSWORD: {
        value: '31',
        label: getLabelText({key: 'remote.enumerate.handleMtdAccountPassword', text: 'MTD账号密码处理'}),
        serviceType: '31',
        serverType: '31',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.handleMtdAccountPassword', text: 'MTD账号密码处理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.handleMtdAccountPassword', text: 'MTD账号密码处理'}),
        include: 0
    },
    REMOVE_MTD_LOGIN_VERIFICATION_METHOD: {
        value: '32',
        label: getLabelText({key: 'remote.enumerate.removeMtdLoginVerificationMethod', text: 'MTD登录验证方式移除'}),
        serviceType: '32',
        serverType: '32',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({
            key: 'remote.enumerate.removeMtdLoginVerificationMethod',
            text: 'MTD登录验证方式移除'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.removeMtdLoginVerificationMethod',
            text: 'MTD登录验证方式移除'
        }),
        include: 0
    },
    HANDLE_TAX_UNACCOUNTED_FOR: {
        value: '33',
        label: getLabelText({key: 'remote.enumerate.handleTaxUnaccountedFor', text: '税金未入账处理'}),
        serviceType: '33',
        serverType: '33',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.handleTaxUnaccountedFor', text: '税金未入账处理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.handleTaxUnaccountedFor', text: '税金未入账处理'}),
        include: 0
    },
    BIND_BANK_ACCOUNT: {
        value: '34',
        label: getLabelText({key: 'remote.enumerate.bindBankAccount', text: '银行账户绑定'}),
        serviceType: '34',
        serverType: '34',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.bindBankAccount', text: '银行账户绑定'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.bindBankAccount', text: '银行账户绑定'}),
        include: 0
    },
    HANDLE_NO_PORT_DECLARATION: {
        value: '35',
        label: getLabelText({key: 'remote.enumerate.handleNoPortDeclaration', text: '无端口申报处理'}),
        serviceType: '35',
        serverType: '35',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.handleNoPortDeclaration', text: '无端口申报处理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.handleNoPortDeclaration', text: '无端口申报处理'}),
        include: 0
    },
    CUSTOMIZE_ADD_SERVICE: {
        value: '36',
        label: getLabelText({key: 'remote.enumerate.customizeAddService', text: '自定义附加服务'}),
        serviceType: '36',
        serverType: '36',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.customizeAddService', text: '自定义附加服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.customizeAddService', text: '自定义附加服务'}),
        include: 0
    },
    CHANGE_VAT_COMPANY_NAME: {
        value: '37',
        label: getLabelText({key: 'remote.enumerate.changeVatCompanyName', text: 'VAT税号公司名称更改'}),
        serviceType: '37',
        serverType: '37',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.changeVatCompanyName', text: 'VAT税号公司名称更改'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.changeVatCompanyName', text: 'VAT税号公司名称更改'}),
        include: 0
    },
    CDS_REGISTRATION: {
        value: '38',
        label: getLabelText({key: 'remote.enumerate.cdsRegistration', text: 'CDS注册'}),
        serviceType: '38',
        serverType: '38',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.cdsRegistration', text: 'CDS注册'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.cdsRegistration', text: 'CDS注册'}),
        include: 0
    },
    COMM_REG_AND_BOOKKEEPING_TAX: {
        value: '39',
        label: getLabelText({key: 'remote.enumerate.commRegAndBookkeepingTax', text: '公司注册+记账报税'}),
        serviceType: '39',
        serverType: '39',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeScpn', text: 'SCPN'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.commRegAndBookkeepingTax', text: '公司注册+记账报税'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.commRegAndBookkeepingTax', text: '公司注册+记账报税'}),
        include: 0
    },
    BOOKKEEPING_TAX: {
        value: '40',
        label: getLabelText({key: 'remote.enumerate.bookkeepingTax', text: '记账报税'}),
        serviceType: '40',
        serverType: '40',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeScpn', text: 'SCPN'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.bookkeepingTax', text: '记账报税'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.bookkeepingTax', text: '记账报税'}),
        include: 0
    },
    RFC_REGISTER: {
        value: '41',
        label: getLabelText({key: 'remote.enumerate.rfcRegister', text: 'RFC注册申报'}),
        serviceType: '41',
        serverType: '41',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeRfc', text: 'RFC'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.rfcRegister', text: 'RFC注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.rfcRegister', text: 'RFC注册申报'}),
        include: 0,
        isMainService: 1
    },
    RFC_TRANSFER_AGENT: {
        value: '69',
        label: getLabelText({key: 'remote.enumerate.rfcTransformDeclaration', text: 'RFC转代理'}),
        serviceType: '69',
        serverType: '69',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeRfc', text: 'RFC'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.rfcTransformDeclaration', text: 'RFC转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.rfcTransformDeclaration', text: 'RFC转代理'}),
        include: 0,
        isMainService: 1
    },
    RFC_RENEW: {
        value: '42',
        label: getLabelText({key: 'remote.enumerate.rfcRenew', text: 'RFC授权续费'}),
        serviceType: '42',
        serverType: '42',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeRfc', text: 'RFC'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.rfcRenew', text: 'RFC授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.rfcRenew', text: 'RFC授权续费'}),
        include: 0
    },
    RFC_LOGOFF: {
        value: '47',
        label: getLabelText({key: 'remote.enumerate.rfcLogoff', text: 'RFC注销'}),
        serviceType: '47',
        serverType: '47',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeRfc', text: 'RFC'}),
        serverName: getLabelText({key: 'remote.enumerate.rfcLogoff', text: 'RFC注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.rfcLogoff', text: 'RFC注销'}),
        include: 0
    },
    IOSS_LOGOFF: {
        value: '48',
        label: getLabelText({key: 'remote.enumerate.iossLogoff', text: 'IOSS注销'}),
        serviceType: '48',
        serverType: '48',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeIoss', text: 'IOSS'}),
        serverName: getLabelText({key: 'remote.enumerate.iossLogoff', text: 'IOSS注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.iossLogoff', text: 'IOSS注销'}),
        include: 0
    },
    OSS_LOGOFF: {
        value: '49',
        label: getLabelText({key: 'remote.enumerate.ossRegistrationDeclaration', text: 'OSS注册申报'}),
        serviceType: '49',
        serverType: '49',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeOss', text: 'OSS'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.ossRegistrationDeclaration', text: 'OSS注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.ossRegistrationDeclaration', text: 'OSS注册申报'}),
        include: 0,
        isMainService: 1
    },
    OSS_TRANSFER_AGENT: {
        value: '50',
        label: getLabelText({key: 'remote.enumerate.ossTransferAgent', text: 'OSS转代理'}),
        serviceType: '50',
        serverType: '50',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeOss', text: 'OSS'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.ossTransferAgent', text: 'OSS转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.ossTransferAgent', text: 'OSS转代理'}),
        include: 0,
        isMainService: 1
    },
    JCT_CANCELLATION: {
        value: '51',
        label: getLabelText({key: 'remote.enumerate.jctCancellation', text: 'JCT注销'}),
        serviceType: '51',
        serverType: '51',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.JCT', text: 'JCT'}),
        serverName: getLabelText({key: 'remote.enumerate.jctCancellation', text: 'JCT注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.jctCancellation', text: 'JCT注销'}),
        include: 0
    },
  EURO_APPLICATION: {
      value: '67',
      label: getLabelText({ key: 'remote.enumerate.belongingToTypeEutaxNumberApplication', text: '欧盟税号申请' }),
      serviceType: '67',
      serverType: '67',
      vatIncrement: 1,
      belongingToType: getLabelText({
        key: 'remote.enumerate.belongingToTypeEutaxNumberApplication',
        text: '欧盟税号申请'
      }),
      serverName: getLabelText({ key: 'remote.enumerate.belongingToTypeEutaxNumberApplication', text: '欧盟税号申请' }),
      serverDetailName: getLabelText({
        key: 'remote.enumerate.belongingToTypeEutaxNumberApplication',
        text: '欧盟税号申请'
      }),
      include: 0,
    //   copyData: true,
    },
    MODIFY_TAXNUMBER_INFORMATION: {
      value: '78',
      label: getLabelText({ key: 'remote.enumerate.modifyTaxNumberInformation', text: '修改税号信息' }),
      serviceType: '78',
      serverType: '78',
      vatIncrement: 1,
      belongingToType: getLabelText({
        key: 'remote.enumerate.modifyTaxNumberInformation',
        text: '修改税号信息'
      }),
      serverName: getLabelText({ key: 'remote.enumerate.modifyTaxNumberInformation', text: '修改税号信息' }),
      serverDetailName: getLabelText({
        key: 'remote.enumerate.modifyTaxNumberInformation',
        text: '修改税号信息'
      }),
      include: 0,
    //   copyData: true,
    },
    VAT_VALUE_ADDED_SERVICES: {
        value: '88',
        label: getLabelText({key: 'remote.enumerate.vatValueAddedServices', text: 'VAT+增值服务'}),
        serviceType: '88',
        serverType: '88',
        vatIncrement: 1,
        copyData: true,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.vatValueAddedServices', text: 'VAT+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.vatValueAddedServices', text: 'VAT+增值服务'}),
        include: 0
    },
    VAT_PERIPHERAL_SERVICE: {
        value: '95',
        label: getLabelText({key: 'remote.enumerate.vatPeripheralService', text: 'VAT周边服务'}),
        serviceType: '95',
        serverType: '95',
        vatIncrement: 1,
        copyData: true,
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        serverName: getLabelText({key: 'remote.enumerate.vatPeripheralService', text: 'VAT周边服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.vatPeripheralService', text: 'VAT周边服务'}),
        include: 0,
        primaryService: 1,
    },
    WEEE_ADD_BRAND: {
        value: '106',
        label: getLabelText({key: 'remote.enumerate.weeeAddBrand', text: 'WEEE追加品类'}),
        serviceType: '106',
        serverType: '106',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        serverName: getLabelText({key: 'remote.enumerate.weeeAddBrand', text: 'WEEE追加'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.weeeAddBrand', text: 'WEEE追加品类'}),
        include: 1
    },
    WEEE_ADD_WEIGHT: {
        value: '149',
        label: getLabelText({key: 'remote.enumerate.weeeAddWeight', text: 'WEEE追加重量'}),
        serviceType: '149',
        serverType: '149',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        serverName: getLabelText({key: 'remote.enumerate.weeeAddWeight', text: 'WEEE追加'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.weeeAddWeight', text: 'WEEE追加重量'}),
        include: 1
    },
    EFILLING_DECLARETION: {
        value: '153',
        label: getLabelText({key: 'remote.common.EfillingDeclaration', text: 'Efiling申报'}),
        serviceType: '153',
        serverType: '153',
        copyData: true,
        belongingToType: getLabelText({key: 'remote.common.EfillingDeclaration', text: 'Efiling申报'}),
        serverName: getLabelText({key: 'remote.common.EfillingDeclaration', text: 'Efiling申报'}),
        serverDetailName: getLabelText({key: 'remote.common.EfillingDeclaration', text: 'Efiling申报'}),
        include: 7
    },
    EUDR_CERTIFICATION: {
        value: '154',
        label: getLabelText({key: 'remote.enumerate.eudrCertification', text: 'EUDR认证'}),
        serviceType: '154',
        serverType: '154',
        primaryService: 1,
        copyData: true,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        serverName: getLabelText({key: 'remote.enumerate.eudrCertification', text: 'EUDR认证'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.eudrCertification', text: 'EUDR认证'}),
        include: 7
    },
    PLASTIC_TAX_ADD_WEIGHT: {
        value: '143',
        label: getLabelText({key: 'remote.enumerate.plasticTaxAdditionalWeight', text: '塑料税追加重量'}),
        serviceType: '143',
        serverType: '143',
        belongingToType: getLabelText({key: 'remote.common.plasticTax', text: '塑料税'}),
        serverName: getLabelText({key: 'remote.enumerate.plasticTaxAdditional', text: '塑料税追加'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.plasticTaxAdditionalWeight', text: '塑料税追加重量'}),
        include: 1
    },
    PACKING_ADD_BRAND: {
        value: '107',
        label: getLabelText({key: 'remote.enumerate.packingAddBrand', text: '包装法追加品类'}),
        serviceType: '107',
        serverType: '107',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        serverName: getLabelText({key: 'remote.enumerate.packingAddBrand', text: '包装法追加'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.packingAddBrand', text: '包装法追加品类'}),
        include: 1
    },
    BATTERY_ADD_BRAND: {
        value: '108',
        label: getLabelText({key: 'remote.enumerate.batteryAddBrand', text: '电池法追加品类'}),
        serviceType: '108',
        serverType: '108',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        serverName: getLabelText({key: 'remote.enumerate.batteryAddBrand', text: '电池法追加'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.batteryAddBrand', text: '电池法追加品类'}),
        include: 1
    },
    PLASTIC_TAX_ADD_BRAND: {
        value: '109',
        label: getLabelText({key: 'remote.enumerate.plasticTaxAdditionalCategory', text: '塑料税追加品类'}),
        serviceType: '109',
        serverType: '109',
        belongingToType: getLabelText({key: 'remote.common.plasticTax', text: '塑料税'}),
        serverName: getLabelText({key: 'remote.enumerate.plasticTaxAdditional', text: '塑料税追加'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.plasticTaxAdditionalCategory', text: '塑料税追加品类'}),
        include: 1
    },
    WEEE_INCREMENT: {
        value: '110',
        label: getLabelText({key: 'remote.enumerate.weeeIncrement', text: 'WEEE增值服务'}),
        serviceType: '110',
        serverType: '110',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        serverName: getLabelText({key: 'remote.enumerate.weeeIncrement', text: 'WEEE增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.weeeIncrement', text: 'WEEE增值服务'}),
        include: 1
    },
    PACKING_INCREMENT: {
        value: '111',
        label: getLabelText({key: 'remote.enumerate.packingIncrement', text: '包装法增值服务'}),
        serviceType: '111',
        serverType: '111',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        serverName: getLabelText({key: 'remote.enumerate.packingIncrement', text: '包装法增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.packingIncrement', text: '包装法增值服务'}),
        include: 1
    },
    BATTERY_INCREMENT: {
        value: '112',
        label: getLabelText({key: 'remote.enumerate.batteryIncrement', text: '电池法增值服务'}),
        serviceType: '112',
        serverType: '112',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        serverName: getLabelText({key: 'remote.enumerate.batteryIncrement', text: '电池法增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.batteryIncrement', text: '电池法增值服务'}),
        include: 1
    },
    WEEE_PLUS_INCREMENT: {
        value: '8001',
        label: getLabelText({key: 'remote.enumerate.weeePlusIncrement', text: 'WEEE+增值服务'}),
        serviceType: '8001',
        serverType: '8001',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        serverName: getLabelText({key: 'remote.enumerate.weeePlusIncrement', text: 'WEEE+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.weeePlusIncrement', text: 'WEEE+增值服务'}),
        include: 1
    },
    BATTERY_PLUS_INCREMENT: {
        value: '8002',
        label: getLabelText({key: 'remote.enumerate.batteryPlusIncrement', text: '电池法+增值服务'}),
        serviceType: '8002',
        serverType: '8002',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        serverName: getLabelText({key: 'remote.enumerate.batteryPlusIncrement', text: '电池法+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.batteryPlusIncrement', text: '电池法+增值服务'}),
        include: 1
    },
    PACKING_PLUS_INCREMENT: {
        value: '8003',
        label: getLabelText({key: 'remote.enumerate.packingPlusIncrement', text: '包装法+增值服务'}),
        serviceType: '8003',
        serverType: '8003',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        serverName: getLabelText({key: 'remote.enumerate.packingPlusIncrement', text: '包装法+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.packingPlusIncrement', text: '包装法+增值服务'}),
        include: 1
    },
    TEXTILE_PLUS_INCREMENT: {
        value: '8004',
        label: getLabelText({key: 'remote.enumerate.textilePlusIncrement', text: '纺织法+增值服务'}),
        serviceType: '8004',
        serverType: '8004',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTextileLaw', text: '纺织法'}),
        serverName: getLabelText({key: 'remote.enumerate.textilePlusIncrement', text: '纺织法+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.textilePlusIncrement', text: '纺织法+增值服务'}),
        include: 1
    },
    TOY_PLUS_INCREMENT: {
        value: '8005',
        label: getLabelText({key: 'remote.enumerate.toyPlusIncrement', text: '玩具法+增值服务'}),
        serviceType: '8005',
        serverType: '8005',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeToyLaw', text: '玩具法'}),
        serverName: getLabelText({key: 'remote.enumerate.toyPlusIncrement', text: '玩具法+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.toyPlusIncrement', text: '玩具法+增值服务'}),
        include: 1
    },
    TYRE_PLUS_INCREMENT: {
        value: '8006',
        label: getLabelText({key: 'remote.enumerate.tyrePlusIncrement', text: '轮胎法+增值服务'}),
        serviceType: '8006',
        serverType: '8006',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTireLaw', text: '轮胎法'}),
        serverName: getLabelText({key: 'remote.enumerate.tyrePlusIncrement', text: '轮胎法+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.tyrePlusIncrement', text: '轮胎法+增值服务'}),
        include: 1
    },
    SL_PLUS_INCREMENT: {
        value: '8007',
        label: getLabelText({key: 'remote.enumerate.slPlusIncrement', text: '体育和休闲运动+增值服务'}),
        serviceType: '8007',
        serverType: '8007',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeSportsAndRecreation', text: '体育和休闲运动'}),
        serverName: getLabelText({key: 'remote.enumerate.slPlusIncrement', text: '体育和休闲运动+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.slPlusIncrement', text: '体育和休闲运动+增值服务'}),
        include: 1
    },
    DIY_PLUS_INCREMENT: {
        value: '8008',
        label: getLabelText({key: 'remote.enumerate.diyPlusIncrement', text: 'DIY和园艺工具+增值服务'}),
        serviceType: '8008',
        serverType: '8008',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeDiyAndGardenTools', text: 'DIY和园艺工具'}),
        serverName: getLabelText({key: 'remote.enumerate.diyPlusIncrement', text: 'DIY和园艺工具+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.diyPlusIncrement', text: 'DIY和园艺工具+增值服务'}),
        include: 1
    },
    PAPER_PLUS_INCREMENT: {
        value: '8009',
        label: getLabelText({key: 'remote.enumerate.paperPlusIncrement', text: '纸张法+增值服务'}),
        serviceType: '8009',
        serverType: '8009',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePaperLaw', text: '纸张法'}),
        serverName: getLabelText({key: 'remote.enumerate.paperPlusIncrement', text: '纸张法+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.paperPlusIncrement', text: '纸张法+增值服务'}),
        include: 1
    },
    HF_PLUS_INCREMENT: {
        value: '8010',
        label: getLabelText({key: 'remote.enumerate.hfPlusIncrement', text: '家具法+增值服务'}),
        serviceType: '8010',
        serverType: '8010',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeFurnitureLaw', text: '家具法'}),
        serverName: getLabelText({key: 'remote.enumerate.hfPlusIncrement', text: '家具法+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.hfPlusIncrement', text: '家具法+增值服务'}),
        include: 1
    },
    PLASTIC_TAX_PLUS_INCREMENT: {
        value: '8011',
        label: getLabelText({key: 'remote.enumerate.plasticTaxPlusIncrement', text: '塑料税+增值服务'}),
        serviceType: '8011',
        serverType: '8011',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePlasticTax', text: '塑料税'}),
        serverName: getLabelText({key: 'remote.enumerate.plasticTaxPlusIncrement', text: '塑料税+增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.plasticTaxPlusIncrement', text: '塑料税+增值服务'}),
        include: 1
    },
    EU_INCREMENT: {
        value: '113',
        label: getLabelText({key: 'remote.enumerate.euIncrement', text: '授权代表增值服务'}),
        serviceType: '113',
        serverType: '113',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeAuthorizedRepresentative',
            text: '授权代表'
        }),
        serverName: getLabelText({key: 'remote.enumerate.euIncrement', text: '授权代表增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.euIncrement', text: '授权代表增值服务'}),
        include: 2
    },
    UK_INCREMENT: {
        value: '114',
        label: getLabelText({key: 'remote.enumerate.ukIncrement', text: '英代增值服务'})
    },
    TEXTILE_LAW_DECLARATION: {
        value: '115',
        label: getLabelText({key: 'remote.enumerate.textileLawDeclaration', text: '纺织法注册服务'}),
        serviceType: '115',
        serverType: '115',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTextileLaw', text: '纺织法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeTextileLaw', text: '纺织法'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.textileLawRegistrationApplication',
            text: '纺织法注册申报'
        }),
        include: 1,
        isMainService: 1
    },
    TEXTILE_LAW_RENEW: {
        value: '215',
        label: getLabelText({key: 'remote.enumerate.textileLawRenew', text: '纺织法续费'}),
        serviceType: '215',
        serverType: '215',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTextileLaw', text: '纺织法'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.textileLawRenew', text: '纺织法续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.textileLawRenew', text: '纺织法续费'}),
        include: 1
    },
    TEXTILE_ADD_WEIGHT: {
        value: '181',
        label: getLabelText({key: 'remote.enumerate.textileAddWeight', text: '纺织法追加重量'}),
        serviceType: '181',
        serverType: '181',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTextileLaw', text: '纺织法'}),
        serverName: getLabelText({key: 'remote.enumerate.textileAddWeight', text: '纺织法追加重量'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.textileAddWeight', text: '纺织法追加重量'}),
        include: 1
    },

    HOME_FURNISHING_DECLARATION: {
        value: '116',
        label: getLabelText({key: 'remote.enumerate.homeFurnishingDeclaration', text: '家具法注册服务'}),
        serviceType: '116',
        serverType: '116',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeFurnitureLaw', text: '家具法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeFurnitureLaw', text: '家具法'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.furnitureLawRegistrationApplication',
            text: '家具法注册申报'
        }),
        include: 1,
        isMainService: 1
    },
    HOME_TRANSFORM_DECLARATION: {
        value: '226',
        label: getLabelText({key: 'remote.enumerate.homeFurnishingTransformDeclaration', text: '家具法转代理'}),
        serviceType: '226',
        serverType: '226',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.theFurnitureAct', text: '家具法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.homeFurnishingTransformDeclaration', text: '家具法转代理'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.homeFurnishingTransformDeclaration',
            text: '家具法转代理'
        }),
        include: 1,
        isMainService: 1
    },
    HOME_FURNISHING_RENEW: {
        value: '216',
        label: getLabelText({key: 'remote.enumerate.homeFurnishingRenew', text: '家具法续费'}),
        serviceType: '216',
        serverType: '216',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeFurnitureLaw', text: '家具法'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.homeFurnishingRenew', text: '家具法续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.homeFurnishingRenew', text: '家具法续费'}),
        include: 1
    },
    TESTING_AND_CERTIFICATION: {
        value: '150',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        serviceType: '150',
        serverType: '150',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        include: 7,
        isMainService: 1
    },
    TRANSPORT_IDENTIFICATION: {
        value: '356',
        label: getLabelText({key: 'remote.enumerate.cargoTransportAppraisal', text: '货物运输鉴定'}),
        serviceType: '356',
        serverType: '356',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.cargoTransportAppraisal', text: '货物运输鉴定'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.cargoTransportAppraisal', text: '货物运输鉴定'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.cargoTransportAppraisal', text: '货物运输鉴定'}),
        include: 7
    },
    MATERIAL_SAFETY_DATA_SHEET: {
        value: '357',
        label: getLabelText({key: 'remote.enumerate.MSDSChemicalSafetyDataSheet', text: 'MSDS化学品安全技术说明书'}),
        serviceType: '357',
        serverType: '357',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.MSDSChemicalSafetyDataSheet', text: 'MSDS化学品安全技术说明书'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.MSDSChemicalSafetyDataSheet', text: 'MSDS化学品安全技术说明书'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.MSDSChemicalSafetyDataSheet', text: 'MSDS化学品安全技术说明书'}),
        include: 7
    },
    COA_ANALYSIS_CERTIFICATE: {
        value: '363',
        label: getLabelText({key: 'remote.common.COAAnalysisCertificate', text: 'COA分析证书'}),
        serviceType: '363',
        serverType: '363',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.COAAnalysisCertificate', text: 'COA分析证书'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.common.COAAnalysisCertificate', text: 'COA分析证书'}),
        serverDetailName: getLabelText({key: 'remote.common.COAAnalysisCertificate', text: 'COA分析证书'}),
        include: 7
    },
    TDS_CHEMICAL_TECHNICAL_DATA_SHEET: {
        value: '364',
        label: getLabelText({key: 'remote.common.TDSChemicalTechnicalDataSheet', text: 'TDS化学品技术数据单'}),
        serviceType: '364',
        serverType: '364',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.TDSChemicalTechnicalDataSheet', text: 'TDS化学品技术数据单'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.common.TDSChemicalTechnicalDataSheet', text: 'TDS化学品技术数据单'}),
        serverDetailName: getLabelText({key: 'remote.common.TDSChemicalTechnicalDataSheet', text: 'TDS化学品技术数据单'}),
        include: 7
    },
    COMPOSITION_ANALYSIS: {
        value: '358',
        label: getLabelText({key: 'remote.enumerate.compositionAnalysis', text: '成分分析'}),
        serviceType: '358',
        serverType: '358',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.compositionAnalysis', text: '成分分析'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.compositionAnalysis', text: '成分分析'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.compositionAnalysis', text: '成分分析'}),
        include: 7
    },
    AMENDMENT_REPORT: {
        value: '359',
        label: getLabelText({key: 'remote.enumerate.reportRevision', text: '修改报告'}),
        serviceType: '359',
        serverType: '359',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.reportRevision', text: '修改报告'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.reportRevision', text: '修改报告'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.reportRevision', text: '修改报告'}),
        include: 7
    },
    TESTING_AND_CERTIFICATION_UNIVERSAL: {
        value: '360',
        label: getLabelText({key: 'remote.common.universalTestingCertification', text: '检测认证（通用）'}),
        serviceType: '360',
        serverType: '360',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.universalTestingCertification', text: '检测认证（通用）'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.common.universalTestingCertification', text: '检测认证（通用）'}),
        serverDetailName: getLabelText({key: 'remote.common.universalTestingCertification', text: '检测认证（通用）'}), 
        include: 7
    },
    TESTING_AND_CERTIFICATION_REPORT: {
        value: '152',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertificationReport', text: '检测认证验证报告'}),
        serviceType: '152',
        serverType: '152',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertificationReport', text: '检测认证验证报告'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertificationReport', text: '检测认证验证报告'}),
        include: 7
    },
    CE_TESTING_DECLARATION: {
        value: '117',
        label: getLabelText({key: 'remote.enumerate.ceTestingDeclaration', text: 'CE检测认证'}),
        serviceType: '117',
        serverType: '117',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.ceTestingDeclaration', text: 'CE检测认证'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.ceTestingDeclaration', text: 'CE检测认证'}),
        include: 7,
        isMainService: 1
    },
    UK_CA_DECLARATION: {
        value: '118',
        label: getLabelText({key: 'remote.enumerate.ukCaDeclaration', text: 'UKCA检测认证'}),
        serviceType: '118',
        serverType: '118',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.ukCaDeclaration', text: 'UKCA检测认证'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.ukCaDeclaration', text: 'UKCA检测认证'}),
        include: 7,
        isMainService: 1
    },
    EU_ENERGY_DECLARATION: {
        value: '119',
        label: getLabelText({key: 'remote.enumerate.euEnergyDeclaration', text: '能效标签'}),
        serviceType: '119',
        serverType: '119',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        primaryService: 1,
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.euEnergyDeclaration', text: '能效标签'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.euEnergyDeclaration', text: '能效标签'}),
        include: 7,
        isMainService: 1
    },
    TESTING_INCREMENT: {
        value: '121',
        label: getLabelText({key: 'remote.enumerate.testingIncrement', text: '检测认证增值服务'}),
        serviceType: '121',
        serverType: '121',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTestingCertification', text: '检测认证'}),
        serverName: getLabelText({key: 'remote.enumerate.testingIncrement', text: '检测认证增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.testingIncrement', text: '检测认证增值服务'}),
        include: 7
    },
    TOY_DECLARATION: {
        value: '122',
        label: getLabelText({key: 'remote.enumerate.toyDeclaration', text: '玩具法注册申报'}),
        serviceType: '122',
        serverType: '122',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeToyLaw', text: '玩具法'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.toyDeclaration', text: '玩具法注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.toyDeclaration', text: '玩具法注册申报'}),
        include: 1,
        isMainService: 1
    },
    TOY_TRANSFORM_DECLARATION: {
        value: '332',
        label: getLabelText({key: 'remote.enumerate.toyTransformDeclaration', text: '玩具法转代理'}),
        serviceType: '332',
        serverType: '332',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.toyLaw', text: '玩具法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.toyTransformDeclaration', text: '玩具法转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.toyTransformDeclaration', text: '玩具法转代理'}),
        include: 1,
        isMainService: 1
    },
    TOY_RENEW: {
        value: '222',
        label: getLabelText({key: 'remote.enumerate.toyRenew', text: '玩具法续费'}),
        serviceType: '222',
        serverType: '222',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeToyLaw', text: '玩具法'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.toyRenew', text: '玩具法续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.toyRenew', text: '玩具法续费'}),
        include: 1
    },
    PLASTIC_TAX_DECLARATION: {
        value: '123',
        label: getLabelText({key: 'remote.enumerate.plasticTaxDeclaration', text: '塑料税注册申报'}),
        serviceType: '123',
        serverType: '123',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePlasticTax', text: '塑料税'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.plasticTaxDeclaration', text: '塑料税注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.plasticTaxDeclaration', text: '塑料税注册申报'}),
        include: 1,
        isMainService: 1
    },
    PLASTIC_TAX_RENEW: {
        value: '223',
        label: getLabelText({key: 'remote.enumerate.plasticTaxRenew', text: '塑料税授权续费'}),
        serviceType: '223',
        serverType: '223',
        vatIncrement: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePlasticTax', text: '塑料税'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.plasticTaxRenew', text: '塑料税授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.plasticTaxRenew', text: '塑料税授权续费'}),
        include: 1
    },
    GST_REGISTER: {
        value: '43',
        label: getLabelText({key: 'remote.enumerate.gstRegister', text: 'GST注册申报'}),
        serviceType: '43',
        serverType: '43',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeGst', text: 'GST'}),
        primaryService: 1,
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.gstRegister', text: 'GST注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.gstRegister', text: 'GST注册申报'}),
        include: 0,
        isMainService: 1
    },
    GST_TRANSFORM_DECLARATION: {
        value: '44',
        label: getLabelText({key: 'remote.enumerate.gstTransformDeclaration', text: 'GST转代理'}),
        serviceType: '44',
        serverType: '44',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeGst', text: 'GST'}),
        primaryService: 1,
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.gstTransformDeclaration', text: 'GST转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.gstTransformDeclaration', text: 'GST转代理'}),
        include: 0,
        isMainService: 1
    },
    GST_RENEW: {
        value: '45',
        label: getLabelText({key: 'remote.enumerate.gstRenew', text: 'GST授权续费'}),
        serviceType: '45',
        serverType: '45',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeGst', text: 'GST'}),
        isRenewal: true,
        vatIncrement: 1,
        serverName: getLabelText({key: 'remote.enumerate.gstRenew', text: 'GST授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.gstRenew', text: 'GST授权续费'}),
        include: 0
    },
    GST_CANCELLATION: {
        value: '46',
        label: getLabelText({key: 'remote.enumerate.gstCancellation', text: 'GST税号注销'}),
        serviceType: '46',
        serverType: '46',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeGst', text: 'GST'}),
        vatIncrement: 1,
        serverName: getLabelText({key: 'remote.enumerate.gstCancellation', text: 'GST税号注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.gstCancellation', text: 'GST税号注销'}),
        include: 0
    },
    VOEC_REGISTER: {
        value: '70',
        label: getLabelText({key: 'remote.enumerate.voecRegister', text: 'VOEC注册申报'}),
        serviceType: '70',
        serverType: '70',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeVoec', text: 'VOEC'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.voecRegister', text: 'VOEC注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.voecRegister', text: 'VOEC注册申报'}),
        include: 0,
        isMainService: 1
    },
    VOEC_TRANSFORM_DECLARATION: {
        value: '71',
        label: getLabelText({key: 'remote.enumerate.voecTransformDeclaration', text: 'VOEC转代理'}),
        serviceType: '71',
        serverType: '71',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeVoec', text: 'VOEC'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.voecTransformDeclaration', text: 'VOEC转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.voecTransformDeclaration', text: 'VOEC转代理'}),
        include: 0,
        isMainService: 1
    },
    VOEC_CANCELLATION: {
        value: '72',
        label: getLabelText({key: 'remote.enumerate.voecCancellation', text: 'VOEC税号注销'}),
        serviceType: '72',
        serverType: '72',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeVoec', text: 'VOEC'}),
        vatIncrement: 1,
        serverName: getLabelText({key: 'remote.enumerate.voecCancellation', text: 'VOEC税号注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.voecCancellation', text: 'VOEC税号注销'}),
        include: 0
    },
    VOEC_RENEW: {
        value: '73',
        label: getLabelText({key: 'remote.enumerate.voecRenew', text: 'VOEC授权续费'}),
        serviceType: '73',
        serverType: '73',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeVoec', text: 'VOEC'}),
        isRenewal: true,
        vatIncrement: 1,
        serverName: getLabelText({key: 'remote.enumerate.voecRenew', text: 'VOEC授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.voecRenew', text: 'VOEC授权续费'}),
        include: 0
    },
    OSS_CANCELLATION: {
        value: '74',
        label: getLabelText({key: 'remote.enumerate.ossCancellation', text: 'OSS注销'}),
        serviceType: '74',
        serverType: '74',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeOss', text: 'OSS'}),
        vatIncrement: 1,
        serverName: getLabelText({key: 'remote.enumerate.ossCancellation', text: 'OSS注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.ossCancellation', text: 'OSS注销'}),
        include: 0
    },
    OSS_RENEW: {
        value: '75',
        label: getLabelText({key: 'remote.enumerate.ossRenew', text: 'OSS续费'}),
        serviceType: '75',
        serverType: '75',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeOss', text: 'OSS'}),
        isRenewal: true,
        vatIncrement: 1,
        serverName: getLabelText({key: 'remote.enumerate.ossRenew', text: 'OSS续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.ossRenew', text: 'OSS续费'}),
        include: 0
    },
    CPNP_DECLARATION: {
        value: '124',
        label: getLabelText({key: 'remote.enumerate.cpnpDeclaration', text: 'CPNP注册'}),
        serviceType: '124',
        serverType: '124',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeCpnp', text: 'CPNP'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.cpnpDeclaration', text: 'CPNP注册'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.cpnpDeclaration', text: 'CPNP注册'}),
        include: 7,
        isMainService: 1
    },
    CPNP_RENEW: {
        value: '224',
        label: getLabelText({key: 'remote.enumerate.cpnpRenew', text: 'CPNP注册续费'}),
        serviceType: '224',
        serverType: '224',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeCpnp', text: 'CPNP'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.cpnpRenew', text: 'CPNP注册续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.cpnpRenew', text: 'CPNP注册续费'}),
        include: 7
    },
    SCPN_DECLARATION: {
        value: '125',
        label: getLabelText({key: 'remote.enumerate.scpnDeclaration', text: 'SCPN注册'}),
        serviceType: '125',
        serverType: '125',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeScpn', text: 'SCPN'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.scpnDeclaration', text: 'SCPN注册'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.scpnDeclaration', text: 'SCPN注册'}),
        include: 7,
        isMainService: 1
    },
    SCPN_RENEW: {
        value: '225',
        label: getLabelText({key: 'remote.enumerate.scpnRenew', text: 'SCPN注册续费'}),
        serviceType: '225',
        serverType: '225',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeScpn', text: 'SCPN'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.scpnRenew', text: 'SCPN注册续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.scpnRenew', text: 'SCPN注册续费'}),
        include: 7
    },
    TYRE_REGISTRATION: {
        value: '129',
        label: getLabelText({key: 'remote.enumerate.tyreRegistration', text: '轮胎法注册申报'}),
        serviceType: '129',
        serverType: '129',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTireLaw', text: '轮胎法'}),
        copyData: true,
        primaryService: 1,
        serverName: getLabelText({key: 'remote.enumerate.tyreRegistration', text: '轮胎法注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.tyreRegistration', text: '轮胎法注册申报'}),
        include: 1,
        isMainService: 1
    },
    TYRE_TRANSFORM_DECLARATION: {
        value: '329',
        label: getLabelText({key: 'remote.enumerate.tyreTransformDeclaration', text: '轮胎法转代理'}),
        serviceType: '329',
        serverType: '329',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.tireMethod', text: '轮胎法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.tyreTransformDeclaration', text: '轮胎法转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.tyreTransformDeclaration', text: '轮胎法转代理'}),
        include: 1,
        isMainService: 1
    },
    TYRE_RENEW: {
        value: '229',
        label: getLabelText({key: 'remote.enumerate.tyreRenew', text: '轮胎法续费'}),
        serviceType: '229',
        serverType: '229',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTireLaw', text: '轮胎法'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.tireLawAuthorizationRenewal', text: '轮胎法授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.tireLawAuthorizationRenewal', text: '轮胎法授权续费'}),
        include: 1
    },
    PAPER_REGISTRATION: {
        value: '130',
        label: getLabelText({key: 'remote.enumerate.paperRegistration', text: '纸张注册申报'}),
        serviceType: '130',
        serverType: '130',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePaperLaw', text: '纸张法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.paperRegistration', text: '纸张注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.paperRegistration', text: '纸张注册申报'}),
        include: 1,
        isMainService: 1
    },
    PAPER_TRANSFORM_DECLARATION: {
        value: '330',
        label: getLabelText({key: 'remote.enumerate.paperTurnServiceType', text: '纸张法转代理'}),
        serviceType: '330',
        serverType: '330',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.paperMethod', text: '纸张法'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.paperTurnServiceType', text: '纸张法转代理'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.paperTurnServiceType', text: '纸张法转代理'}),
        include: 1,
        isMainService: 1
    },
    PAPER_RENEW: {
        value: '230',
        label: getLabelText({key: 'remote.enumerate.paperRenew', text: '纸张法续费'}),
        serviceType: '230',
        serverType: '230',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePaperLaw', text: '纸张法'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.paperLawAuthorizationRenewal', text: '纸张授权续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.paperLawAuthorizationRenewal', text: '纸张授权续费'}),
        include: 1
    },
    CLIMATE_FRIENDLY: {
        value: '131',
        label: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationCarbonNeutral',
            text: '气候友好认证（碳中和）'
        }),
        serviceType: '131',
        serverType: '131',
        primaryService: 1,
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationCarbonNeutral',
            text: '气候友好认证（碳中和）'
        }),
        copyData: true,
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationCarbonNeutral',
            text: '气候友好认证（碳中和）'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationCarbonNeutral',
            text: '气候友好认证（碳中和）'
        }),
        include: 7,
        isMainService: 1
    },
    CLIMATE_RENEW: {
        value: '231',
        label: getLabelText({key: 'remote.enumerate.climateRenew', text: '气候友好认证（碳中和）续费'}),
        serviceType: '231',
        serverType: '231',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationCarbonNeutral',
            text: '气候友好认证（碳中和）'
        }),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.climateRenew', text: '气候友好认证（碳中和）续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.climateRenew', text: '气候友好认证（碳中和）续费'}),
        include: 7
    },
    CLIMATE_INCREMENT: {
        value: '137',
        label: getLabelText({key: 'remote.enumerate.climateIncrement', text: '气候友好认证（碳中和）增值服务'}),
        serviceType: '137',
        serverType: '137',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationCarbonNeutral',
            text: '气候友好认证（碳中和）'
        }),
        serverName: getLabelText({key: 'remote.enumerate.climateIncrement', text: '气候友好认证（碳中和）增值服务'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.climateIncrement',
            text: '气候友好认证（碳中和）增值服务'
        }),
        include: 7
    },
    OEKO_TEX: {
        value: '140',
        label: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationOekoTex',
            text: '气候友好认证（OEKO-TEX认证）'
        }),
        serviceType: '140',
        serverType: '140',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertification',
            text: '气候友好认证'
        }),
        copyData: true,
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationOekoTex',
            text: '气候友好认证（OEKO-TEX认证）'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationOekoTex',
            text: '气候友好认证（OEKO-TEX认证）'
        }),
        include: 7,
        isMainService: 1
    },
    OEKO_TEX_RENEW: {
        value: '240',
        label: getLabelText({key: 'remote.enumerate.oekoTexRenew', text: '气候友好认证（OEKO-TEX）续费'}),
        serviceType: '240',
        serverType: '240',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationOekoTex',
            text: '气候友好认证（OEKO-TEX认证）'
        }),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.oekoTexRenew', text: '气候友好认证（OEKO-TEX）续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.oekoTexRenew', text: '气候友好认证（OEKO-TEX）续费'}),
        include: 7
    },
    OEKO_TEX_INCREMENT: {
        value: '142',
        label: getLabelText({key: 'remote.enumerate.oekoTexIncrement', text: '气候友好认证（OEKO-TEX）增值服务'}),
        serviceType: '142',
        serverType: '142',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeClimateFriendlyCertificationOekoTex',
            text: '气候友好认证（OEKO-TEX认证）'
        }),
        serverName: getLabelText({key: 'remote.enumerate.oekoTexIncrement', text: '气候友好认证（OEKO-TEX）增值服务'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.oekoTexIncrement',
            text: '气候友好认证（OEKO-TEX）增值服务'
        }),
        include: 7
    },
    TEXTILE_INCREMENT: {
        value: '132',
        label: getLabelText({
            key: 'remote.enumerate.belongingToTypeTextileLawValueAddedService',
            text: '纺织法增值服务'
        }),
        serviceType: '132',
        serverType: '132',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeTextileLawValueAddedService',
            text: '纺织法增值服务'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeTextileLawValueAddedService',
            text: '纺织法增值服务'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeTextileLawValueAddedService',
            text: '纺织法增值服务'
        }),
        include: 1
    },
    HF_INCREMENT: {
        value: '133',
        label: getLabelText({
            key: 'remote.enumerate.belongingToTypeFurnitureLawValueAddedService',
            text: '家具法增值服务'
        }),
        serviceType: '133',
        serverType: '133',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeFurnitureLawValueAddedService',
            text: '家具法增值服务'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeFurnitureLawValueAddedService',
            text: '家具法增值服务'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeFurnitureLawValueAddedService',
            text: '家具法增值服务'
        }),
        include: 1
    },
    TOY_INCREMENT: {
        value: '134',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeToyLawValueAddedService', text: '玩具法增值服务'}),
        serviceType: '134',
        serverType: '134',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeToyLawValueAddedService',
            text: '玩具法增值服务'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeToyLawValueAddedService',
            text: '玩具法增值服务'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeToyLawValueAddedService',
            text: '玩具法增值服务'
        }),
        include: 1
    },
    TYRE_INCREMENT: {
        value: '135',
        label: getLabelText({key: 'remote.enumerate.tyreIncrement', text: '轮胎法增值服务'}),
        serviceType: '135',
        serverType: '135',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTireLaw', text: '轮胎法'}),
        serverName: getLabelText({key: 'remote.enumerate.tyreIncrement', text: '轮胎法增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.tyreIncrement', text: '轮胎法增值服务'}),
        include: 1
    },
    PAPER_INCREMENT: {
        value: '136',
        label: getLabelText({key: 'remote.enumerate.belongingToTypePaperLawValueAddedService', text: '纸张增值服务'}),
        serviceType: '136',
        serverType: '136',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypePaperLawValueAddedService',
            text: '纸张增值服务'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypePaperLawValueAddedService',
            text: '纸张增值服务'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypePaperLawValueAddedService',
            text: '纸张增值服务'
        }),
        include: 1
    },
    SPORTS_AND_LEISURE_REGISTRATION:{
        value: '138',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeSportsAndRecreation', text: '体育和休闲运动'}),
        serviceType: '138',
        serverType: '138',
        primaryService: 1,
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeSportsAndRecreation',
            text: '体育和休闲运动'
        }),
        serverName: getLabelText({key: 'remote.enumerate.sportRegistration', text: '体育和休闲运动注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.sportRegistration', text: '体育和休闲运动注册申报'}),
        copyData: true,
        include: 1,
        isMainService: 1
    },
    SPORTS_AND_LEISURE_TRANSFORM_DECLARATION:{
        value: '338',
        label: getLabelText({key: 'remote.enumerate.sportsTransformDeclaration', text: '体育和休闲运动转代理'}),
        serviceType: '338',
        serverType: '338',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.sportsAndRecreationalSports', text: '体育和休闲运动'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.sportsTransformDeclaration', text: '体育和休闲运动转代理'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.sportsTransformDeclaration',
            text: '体育和休闲运动转代理'
        }),
        include: 1,
        isMainService: 1
    },
    //体育和休闲运动续费
    SPORTS_AND_LEISURE_RENEW:{
        value: '238',
        label: getLabelText({key: 'remote.enumerate.sportRenew', text: '体育和休闲运动续费'}),
        serviceType: '238',
        serverType: '238',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeSportsAndRecreation',
            text: '体育和休闲运动'
        }),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.sportRenew', text: '体育和休闲运动续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.sportRenew', text: '体育和休闲运动续费'}),
        include: 1
    },
    SL_INCREMENT: {
        value: '145',
        label: getLabelText({
            key: 'remote.enumerate.belongingToTypeSportsAndRecreationValueAddedService',
            text: '体育与休闲运动增值服务'
        }),
        serviceType: '145',
        serverType: '145',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeSportsAndRecreationValueAddedService',
            text: '体育与休闲运动增值服务'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeSportsAndRecreationValueAddedService',
            text: '体育与休闲运动增值服务'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeSportsAndRecreationValueAddedService',
            text: '体育与休闲运动增值服务'
        }),
        include: 1
    },
    DIY_INCREMENT: {
        value: '146',
        label: getLabelText({
            key: 'remote.enumerate.belongingToTypeDiyAndGardenToolsValueAddedService',
            text: 'DIY和园艺工具增值服务'
        }),
        serviceType: '146',
        serverType: '146',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeDiyAndGardenToolsValueAddedService',
            text: 'DIY和园艺工具增值服务'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeDiyAndGardenToolsValueAddedService',
            text: 'DIY和园艺工具增值服务'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeDiyAndGardenToolsValueAddedService',
            text: 'DIY和园艺工具增值服务'
        }),
        include: 1
    },
    ENERGY_LABEL_INCREMENT: {
        value: '148',
        label: getLabelText({
            key: 'remote.enumerate.belongingToTypeEnergyEfficiencyLabelValueAddedService',
            text: '能效标签增值服务'
        }),
        serviceType: '148',
        serverType: '148',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeEnergyEfficiencyLabelValueAddedService',
            text: '能效标签增值服务'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeEnergyEfficiencyLabelValueAddedService',
            text: '能效标签增值服务'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeEnergyEfficiencyLabelValueAddedService',
            text: '能效标签增值服务'
        }),
        include: 7
    },
    DIY_GARDEN_REGISTRATION: {
        value: '139',
        label: getLabelText({key: 'remote.enumerate.diyGardenRegistration', text: 'DIY和园艺工具注册申报'}),
        serviceType: '139',
        serverType: '139',
        primaryService: 1,
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeDiyAndGardenTools',
            text: 'DIY和园艺工具'
        }),
        serverName: getLabelText({key: 'remote.enumerate.diyGardenRegistration', text: 'DIY和园艺工具注册申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.diyGardenRegistration', text: 'DIY和园艺工具注册申报'}),
        copyData: true,
        include: 1,
        isMainService: 1
    },
    DIY_TRANSFORM_DECLARATION: {
        value: '339',
        label: getLabelText({key: 'remote.enumerate.diyGardenTransformDeclaration', text: 'DIY和园艺工具转代理'}),
        serviceType: '339',
        serverType: '339',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.common.diyAndGardeningTools', text: 'DIY和园艺工具'}),
        serverName: getLabelText({key: 'remote.enumerate.diyGardenTransformDeclaration', text: 'DIY和园艺工具转代理'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.diyGardenTransformDeclaration',
            text: 'DIY和园艺工具转代理'
        }),
        copyData: true,
        include: 1,
        isMainService: 1
    },
    DIY_GARDEN_RENEW: {
        value: '239',
        label: getLabelText({key: 'remote.enumerate.diyGardenRenew', text: 'DIY和园艺工具续费'}),
        serviceType: '239',
        serverType: '239',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeDiyAndGardenTools',
            text: 'DIY和园艺工具'
        }),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.diyGardenRenew', text: 'DIY和园艺工具续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.diyGardenRenew', text: 'DIY和园艺工具续费'}),
        include: 1
    },
    SALES_INVOICING_APPLY: {
        value: '61',
        label: getLabelText({key: 'remote.enumerate.salesInvoicingApply', text: '销售发票申请'}),
        serviceType: '61',
        serverType: '61',
        belongingToType: getLabelText({key: 'VAT', text: 'VAT'}),
        vatIncrement: 1,
        serverName: getLabelText({key: 'remote.enumerate.salesInvoicingApply', text: '销售发票申请'}),
        // serverDetailName: getLabelText({ key: 'remote.enumerate.salesInvoicingApply', text: '销售发票申请' }),
        include: 0
    },
    EG_DOC: {
        value: '166',
        label: getLabelText({key: 'remote.enumerate.egDoc', text: '英代DOC'})
    },
    OG_DOC: {
        value: '167',
        label: getLabelText({key: 'remote.enumerate.ogDoc', text: '欧代DOC'})
    },
    EO_PRODSG: {
        value: '168',
        label: getLabelText({key: 'remote.enumerate.eoProdsG', text: '欧代ProdSG'})
    },
    FR_DOC: {
        value: '169',
        label: getLabelText({key: 'remote.enumerate.frDoc', text: '法国DC'})
    },
    WEEE_ANSWER: {
        value: '170',
        label: getLabelText({key: 'remote.enumerate.weeeQuestionnaireSurvey', text: 'weee问卷调查'})
    },
    PACK_ANSWER: {
        value: '171',
        label: getLabelText({key: 'remote.enumerate.packAnswer', text: '包装法问卷调查'})
    },
    BATTERY_ANSWER: {
        value: '172',
        label: getLabelText({key: 'remote.enumerate.batteryAnswer', text: '电池法问卷调查'})
    },
    TEXTILE_ANSWER: {
        value: '173',
        label: getLabelText({key: 'remote.enumerate.textileAnswer', text: '纺织法问卷调查'})
    },
    TOY_ANSWER: {
        value: '174',
        label: getLabelText({key: 'remote.enumerate.toyAnswer', text: '玩具法问卷调查'})
    },
    HOME_ANSWER: {
        value: '175',
        label: getLabelText({key: 'remote.enumerate.homeAnswer', text: '家具法问卷调查'})
    },
    REGISTRATION_ANSWER: {
        value: '176',
        label: getLabelText({key: 'remote.enumerate.registrationAnswer', text: '园艺工具问卷调查'})
    },
    COMPLIANCE_DOCUMENTS: {
        value: '178',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeComplianceDocument', text: '合规文件'}),
        serviceType: '178',
        serverType: '178',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeComplianceDocument', text: '合规文件'}),
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeComplianceDocument', text: '合规文件'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.belongingToTypeComplianceDocument', text: '合规文件'}),
        include: 2
    },
    ADDITIONAL_WEIGHT_FOR_PACKAGING_METHOD: {
        value: '177',
        label: getLabelText({key: 'remote.enumerate.additionalWeightForPackagingMethod', text: '包装法追加重量'}),
        serviceType: '177',
        serverType: '177',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        serverName: getLabelText({key: 'remote.enumerate.additionalWeightForPackagingMethod', text: '包装法追加重量'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.additionalWeightForPackagingMethod',
            text: '包装法追加重量'
        }),
        include: 1
    },
    BATTERY_ADD_WEIGHT: {
        value: '179',
        label: getLabelText({key: 'remote.enumerate.batteryAddWeight', text: '电池法追加重量'}),
        serviceType: '179',
        serverType: '179',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        serverName: getLabelText({key: 'remote.enumerate.batteryAddWeight', text: '电池法追加重量'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.batteryAddWeight', text: '电池法追加重量'}),
        include: 1
    },
    WEEE_CANCELLATION_SERVCIE: {
        value: '301',
        label: getLabelText({key: 'remote.enumerate.weeeCancellationServcie', text: 'WEEE注销服务'}),
        serviceType: '301',
        serverType: '301',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeWeee', text: 'WEEE'}),
        serverName: getLabelText({key: 'remote.enumerate.weeeCancellation', text: 'WEEE注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.weeeCancellation', text: 'WEEE注销'}),
        include: 1
    },
    PACKING_CANCELLATION: {
        value: '302',
        label: getLabelText({key: 'remote.enumerate.packingCancellation', text: '包装法注销'}),
        serviceType: '302',
        serverType: '302',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePackagingLaw', text: '包装法'}),
        serverName: getLabelText({key: 'remote.enumerate.packingCancellation', text: '包装法注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.packingCancellation', text: '包装法注销'}),
        include: 1
    },
    BATTERY_CANCELLATION: {
        value: '303',
        label: getLabelText({key: 'remote.enumerate.batteryCancellation', text: '电池法注销'}),
        serviceType: '303',
        serverType: '303',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBatteryLaw', text: '电池法'}),
        serverName: getLabelText({key: 'remote.enumerate.batteryCancellation', text: '电池法注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.batteryCancellation', text: '电池法注销'}),
        include: 1
    },
    TEXTILE_CANCELLATION: {
        value: '315',
        label: getLabelText({key: 'remote.enumerate.textileCancellation', text: '纺织法注销'}),
        serviceType: '315',
        serverType: '315',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTextileLaw', text: '纺织法'}),
        serverName: getLabelText({key: 'remote.enumerate.textileCancellation', text: '纺织法注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.textileCancellation', text: '纺织法注销'}),
        include: 1
    },
    HOME_FURNISHING_CANCELLATION: {
        value: '316',
        label: getLabelText({key: 'remote.enumerate.homeFurnishingCancellation', text: '家具法注销'}),
        serviceType: '316',
        serverType: '316',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeFurnitureLaw', text: '家具法'}),
        serverName: getLabelText({key: 'remote.enumerate.homeFurnishingCancellation', text: '家具法注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.homeFurnishingCancellation', text: '家具法注销'}),
        include: 1
    },
    TOY_DECLARATION_CANCELLATION: {
        value: '322',
        label: getLabelText({key: 'remote.enumerate.toyDeclarationCancellation', text: '玩具法注销'}),
        serviceType: '322',
        serverType: '322',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeToyLaw', text: '玩具法'}),
        serverName: getLabelText({key: 'remote.enumerate.toyDeclarationCancellation', text: '玩具法注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.toyDeclarationCancellation', text: '玩具法注销'}),
        include: 1
    },
    PAPER_CANCELLATION: {
        value: '323',
        label: getLabelText({key: 'remote.enumerate.paperCancellation', text: '纸张法注销'}),
        serviceType: '323',
        serverType: '323',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePaperLaw', text: '纸张法'}),
        serverName: getLabelText({key: 'remote.enumerate.paperCancellation', text: '纸张法注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.paperCancellation', text: '纸张法注销'}),
        include: 1
    },
    TYRE_CANCELLATION: {
        value: '324',
        label: getLabelText({key: 'remote.enumerate.tyreCancellation', text: '轮胎法注销'}),
        serviceType: '324',
        serverType: '324',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeTireLaw', text: '轮胎法'}),
        serverName: getLabelText({key: 'remote.enumerate.tyreCancellation', text: '轮胎法注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.tyreCancellation', text: '轮胎法注销'}),
        include: 1
    },
    SPORT_CANCELLATION: {
        value: '325',
        label: getLabelText({key: 'remote.enumerate.sportCancellation', text: '体育和休闲运动注销'}),
        serviceType: '325',
        serverType: '325',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeSportsAndRecreation',
            text: '体育和休闲运动'
        }),
        serverName: getLabelText({key: 'remote.enumerate.sportCancellation', text: '体育和休闲运动注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.sportCancellation', text: '体育和休闲运动注销'}),
        include: 1
    },
    DIY_CANCELLATION: {
        value: '326',
        label: getLabelText({key: 'remote.enumerate.diyCancellation', text: 'DIY和园艺注销'}),
        serviceType: '326',
        serverType: '326',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeDiyAndGardenTools',
            text: 'DIY和园艺工具'
        }),
        serverName: getLabelText({key: 'remote.enumerate.diyCancellation', text: 'DIY和园艺注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.diyCancellation', text: 'DIY和园艺注销'}),
        include: 1
    },
    PLASTIC_CANCELLATION_SERVCIE: {
        value: '328',
        label: getLabelText({key: 'remote.enumerate.plasticCancellationServcie', text: '塑料税注销服务'}),
        serviceType: '328',
        serverType: '328',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePlasticTax', text: '塑料税'}),
        serverName: getLabelText({key: 'remote.enumerate.plasticTaxCancellation', text: '塑料税注销'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.plasticTaxCancellation', text: '塑料税注销'}),
        include: 1
    },
    OST_BALANCE_RECHARGE: {
        value: '1015',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeBalanceRecharge', text: '余额充值'}),
        serviceType: '1015',
        serverType: '1015',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeBalanceRecharge', text: '余额充值'}),
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeBalanceRecharge', text: '余额充值'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.belongingToTypeBalanceRecharge', text: '余额充值'}),
        include: 99
    },
    PRODUCT_REGISTRATION: {
        value: '151',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeProductRegistration', text: '产品注册'}),
        serviceType: '151',
        serverType: '151',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeProductRegistration', text: '产品注册'}),
        copyData: true,
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeProductRegistration', text: '产品注册'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.belongingToTypeProductRegistration', text: '产品注册'}),
        include: 7,
        isMainService: 1
    },
    PRODUCT_REGISTRATION_RENEWAL: {
        value: '251',
        label: getLabelText({key: 'remote.enumerate.productRegistrationRenewal', text: '产品注册续费'}),
        serviceType: '251',
        serverType: '251',
        primaryService: 1,
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeProductRegistration', text: '产品注册'}),
        isRenewal: true,
        serverName: getLabelText({key: 'remote.enumerate.productRegistrationRenewal', text: '产品注册续费'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.productRegistrationRenewal', text: '产品注册续费'}),
        include: 7
    },
    TRADEMARK_REG: {
        value: '10000',
        label: getLabelText({key: 'remote.enumerate.trademarkReg', text: '商标注册'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 1,
        isRenewable: 1,
        hasCloseModule: 1
    },
    TRADEMARK_OATH: {
        value: '10001',
        label: getLabelText({key: 'remote.enumerate.trademarkOath', text: '商标宣誓'}),
        businessType: '2',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.common.receiveNotifications', text: '接收通知'}),
        closeFileName: getLabelText({key: 'remote.common.receiveNotifications', text: '接收通知'}),
        ippSort: 2,
        isRenewable: 1,
        hasFinishModule: 1
    },
    VIP_SERVICE: {
        value: '10002',
        label: getLabelText({key: 'remote.enumerate.vipService', text: '会员服务'})
    },
    GF_SERVICE_REG: {
        value: '10003',
        label: getLabelText({key: 'remote.enumerate.gfServiceReg', text: '商标注册官费'})
    },
    GF_SERVICE_OATH: {
        value: '10004',
        label: getLabelText({key: 'remote.enumerate.gfServiceOath', text: '商标宣誓官费'})
    },
    GF_SERVICE_RENEWAL_OATH: {
        value: '13007',
        label: getLabelText({key: 'remote.common.gfServiceRenewalOath', text: '商标续展及宣誓官费'})
    },
    MDT_VAT_TAX_NUMBER_DEREGISTER: {
        value: '10006',
        label: getLabelText({key: 'remote.enumerate.mdtVatTaxNumberDeregister', text: '注销'})
    },
    TRADEMARK_ASSIGNMENT: {
        value: '10007',
        label: getLabelText({key: 'remote.enumerate.trademarkAssignment', text: '商标转让'}),
        businessType: '3',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameApprovalProof', text: '核准证明'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 3,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    GF_SERVICE_ASSIGN: {
        value: '10008',
        label: getLabelText({key: 'remote.enumerate.gfServiceAssign', text: '商标转让官费'})
    },
    SC_SERVICE: {
        value: '10009',
        label: getLabelText({key: 'remote.enumerate.scService', text: '审查意见答复'})
    },
    VIP_UPGRADE: {
        value: '10010',
        label: getLabelText({key: 'remote.enumerate.vipUpgrade', text: '会员升级服务'})
    },
    APPROVED_HZ_REGISTRATION: {
        value: '10011',
        label: getLabelText({key: 'remote.enumerate.approvedHzRegistration', text: '核准注册'})
    },
    INTENT_NOA_APPLY: {
        value: '10012',
        label: getLabelText({key: 'remote.enumerate.intentNoaApplyOfficialFee', text: '意向申请官费'})
    },
    PATENT_APPLICATION: {
        value: '10013',
        label: getLabelText({key: 'remote.enumerate.patentApplication', text: '外观设计申请'}),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 4,
        isRenewable: 1,
        hasCloseModule: 1
    },
    GF_PATENT_APPLICATION: {
        value: '10014',
        label: getLabelText({key: 'remote.enumerate.gfPatentApplication', text: '外观设计申请官费'})
    },
    GF_AUTHORIZED: {
        value: '10060',
        label: getLabelText({key: 'remote.enumerate.gfAuthorized', text: '授权官费'})
    },
    TRADEMARK_REGISTRATION_AUTHORIZATION_CERTIFICATE: {
        value: '10016',
        label: getLabelText({
            key: 'remote.enumerate.trademarkRegistrationAuthorizationCertificate',
            text: '商标授权费缴纳'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 5,
        isRenewable: 1,
        hasCloseModule: 1
    },
    TRADEMARK_ACCELERATED_EXAMINATION: {
        value: '10017',
        label: getLabelText({key: 'remote.enumerate.trademarkAcceleratedExamination', text: '商标加速审查'}),
        businessType: '1',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 6,
        tag: getLabelText({key: 'remote.enumerate.acceleratedExamination', text: '加速审查'}),
        hasFinishModule: 1
    },
    TRADEMARK_SUBCLASS_SUPPLEMENT: {
        value: '10018',
        label: getLabelText({key: 'remote.enumerate.trademarkSubclassSupplement', text: '商标商品/服务项增加'}),
        businessType: '1',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 7,
        tag: getLabelText({key: 'remote.enumerate.additionOfGoodsServices', text: '商品增加'}),
        hasFinishModule: 1
    },
    TRADEMARK_DESIGNATION_APPLICATION: {
        value: '10019',
        label: getLabelText({key: 'remote.enumerate.trademarkDesignationApplication', text: '商标指定申请'}),
        businessType: '1',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        ippSort: 8,
        hasFinishModule: 1
    },
    TRADEMARK_INFORMATION_SUPPLEMENT: {
        value: '10020',
        label: getLabelText({key: 'remote.enumerate.trademarkInformationSupplement', text: '商标信息补正'}),
        businessType: '1',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 9,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    EVIDENCE_OF_TRADEMARK_USE_RESPONSE: {
        value: '10021',
        label: getLabelText({
            key: 'remote.enumerate.evidenceOfTrademarkUseResponse',
            text: '商标审查意见答复（使用证据答复）'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameProof', text: '证明文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 10,
        tag: getLabelText({key: 'remote.enumerate.officeActionResponse', text: 'OA答复'}),
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    STATEMENT_OF_INTENT_TO_APPLY_FOR_USE: {
        value: '10022',
        label: getLabelText({
            key: 'remote.enumerate.statementOfIntentToApplyForUse',
            text: '意向申请使用证据递交（含官费）'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameProof', text: '证明文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 11,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_SIMILARITY_DEFENSE: {
        value: '10023',
        label: getLabelText({key: 'remote.enumerate.trademarkSimilarityDefense', text: '商标审查意见答复（近似答复）'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameProof', text: '证明文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 12,
        tag: getLabelText({key: 'remote.enumerate.officeActionResponse', text: 'OA答复'}),
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_LACK_OF_DISTINCTIVENESS_DEFENSE: {
        value: '10024',
        label: getLabelText({
            key: 'remote.enumerate.trademarkLackOfDistinctivenessDefense',
            text: '商标审查意见答复（缺乏显著性答复）'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameProof', text: '证明文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 13,
        tag: getLabelText({key: 'remote.enumerate.officeActionResponse', text: 'OA答复'}),
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_REVIVAL_APPLICATION: {
        value: '10025',
        label: getLabelText({key: 'remote.enumerate.trademarkRevivalApplication', text: '商标复活申请'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 14,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    APPLICATION_FOR_TRADEMARK_RENEWAL: {
        value: '10026',
        label: getLabelText({key: 'remote.enumerate.applicationForTrademarkRenewal', text: '商标续展申请'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameProof', text: '证明文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 15,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_HOLDER_INFORMATION_CHANGE: {
        value: '10027',
        label: getLabelText({key: 'remote.enumerate.trademarkHolderInformationChange', text: '商标持有人信息变更'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameProof', text: '证明文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 16,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_AGENT_INFORMATION_CHANGE: {
        value: '10028',
        label: getLabelText({
            key: 'remote.enumerate.trademarkAgentInformationChange',
            text: '商标代理律师变更（转代理）'
        }),
        businessType: '1',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 17,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_VOLUNTARY_CANCELLATION_APPLICATION: {
        value: '10029',
        label: getLabelText({
            key: 'remote.enumerate.trademarkVoluntaryCancellationApplication',
            text: '商标主动撤销申请'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 18,
        hasFinishModule: 1
    },
    WITHDRAWING_SOMEONE_ELSE_APPLICATION_OR_REGISTERED: {
        value: '10030',
        label: getLabelText({
            key: 'remote.enumerate.withdrawingSomeoneElseApplicationOrRegistered',
            text: '商标不使用撤销申请'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 19,
        hasFinishModule: 1
    },
    WITHDRAWAL_OF_PLEA: {
        value: '10031',
        label: getLabelText({key: 'remote.enumerate.withdrawalOfPlea', text: '商标撤销答辩'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameProof', text: '证明文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 20,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    ACTIVE_CANCELLATION_OF_REGISTERED_TRADEMARKS: {
        value: '10032',
        label: getLabelText({
            key: 'remote.enumerate.activeCancellationOfRegisteredTrademarks',
            text: '已注册商标主动注销'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 21,
        hasFinishModule: 1
    },
    FILING_AN_INVALID_APPLICATION: {
        value: '10033',
        label: getLabelText({key: 'remote.enumerate.filingAnInvalidApplication', text: '商标无效申请'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 22,
        hasFinishModule: 1
    },
    INVALID_PLEA: {
        value: '10034',
        label: getLabelText({key: 'remote.enumerate.invalidPlea', text: '商标无效答辩'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 23,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_OPPOSITION_APPLICATION: {
        value: '10035',
        label: getLabelText({key: 'remote.enumerate.trademarkOppositionApplication', text: '商标异议申请'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 24,
        hasFinishModule: 1
    },
    TRADEMARK_OPPOSITION_DEFENSE: {
        value: '10036',
        label: getLabelText({key: 'remote.enumerate.trademarkOppositionDefense', text: '商标异议答辩'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 25,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    OTHER_STAGES_OF_TRADEMARK_OPPOSITION_DEFENSE: {
        value: '10037',
        label: getLabelText({
            key: 'remote.enumerate.otherStagesOfTrademarkOppositionDefense',
            text: '商标异议答辩其他阶段'
        }),
        businessType: '1',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 26,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_CERTIFICATE_RE_ISSUANCE_AND_POSTAGE: {
        value: '10038',
        label: getLabelText({key: 'remote.enumerate.trademarkCertificateReIssuanceAndPostage', text: '商标证书补发'}),
        businessType: '1',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 27,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_OTHER_SERVICES: {
        value: '10039',
        label: getLabelText({key: 'remote.enumerate.trademarkOtherServices', text: '商标其他服务'}),
        businessType: '1',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 28,
        tag: getLabelText({ key: 'remote.common.other', text: '其他' }),
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    TRADEMARK_OATH_EXTENSION: {
        value: '10040',
        label: getLabelText({key: 'remote.enumerate.trademarkOathExtension', text: '商标宣誓宽展申请'}),
        businessType: '2',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 29,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    APPEARANCE_PATENT_ACCELERATED_EXAMINATION: {
        value: '10042',
        label: getLabelText({key: 'remote.enumerate.appearancePatentAcceleratedExamination', text: '外观设计加速审查'}),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 31,
        tag: getLabelText({key: 'remote.enumerate.acceleratedExamination', text: '加速审查'}),
        hasFinishModule: 1
    },
    CHANGE_OF_APPEARANCE_PATENT_HOLDER_INFORMATION: {
        value: '10043',
        label: getLabelText({
            key: 'remote.enumerate.changeOfAppearancePatentHolderInformation',
            text: '外观设计持有人信息变更'
        }),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameApprovalProof', text: '核准证明'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 32,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    CHANGE_OF_APPEARANCE_PATENT_AGENT_INFORMATION: {
        value: '10044',
        label: getLabelText({
            key: 'remote.enumerate.changeOfAppearancePatentAgentInformation',
            text: '外观设计代理律师变更（转代理）'
        }),
        businessType: '4',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 33,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    APPEARANCE_PATENT_AUTHORIZATION_FEE_PAYMENT: {
        value: '10045',
        label: getLabelText({
            key: 'remote.enumerate.appearancePatentAuthorizationFeePayment',
            text: '外观设计授权费缴纳'
        }),
        businessType: '4',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 34,
        isRenewable: 1,
        hasCloseModule: 1
    },
    APPEARANCE_PATENT_ANNUAL_FEE_PAYMENT: {
        value: '10046',
        label: getLabelText({key: 'remote.enumerate.appearancePatentAnnualFeePayment', text: '外观设计年费缴纳'}),
        businessType: '4',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 35,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    APPEARANCE_PATENT_TRANSFER: {
        value: '10047',
        label: getLabelText({key: 'remote.enumerate.appearancePatentTransfer', text: '外观设计转让'}),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 36,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    APPEARANCE_PATENT_EXAMINATION_OPINION_REPLY: {
        value: '10048',
        label: getLabelText({
            key: 'remote.enumerate.appearancePatentExaminationOpinionReply',
            text: '外观设计审查意见答复'
        }),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 37,
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    APPEARANCE_PATENT_DRAWING_SERVICE: {
        value: '10049',
        label: getLabelText({key: 'remote.enumerate.appearancePatentDrawingService', text: '外观设计绘图服务'}),
        businessType: '4',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameDrawing', text: '绘图文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameDrawing', text: '绘图文件'}),
        ippSort: 38,
        tag: getLabelText({key: 'remote.enumerate.drawing', text: '绘图'}),
        hasFinishModule: 1
    },
    APPEARANCE_PATENT_OTHER_SERVICES: {
        value: '10050',
        label: getLabelText({key: 'remote.enumerate.appearancePatentOtherServices', text: '外观设计其他服务'}),
        businessType: '4',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 39,
        tag: getLabelText({ key: 'remote.common.other', text: '其他' }),
        isRenewable: 1,
        hasFinishModule: 1,
        hasCloseModule: 1
    },
    COPYRIGHT_APPLICATION: {
        value: '10051',
        label: getLabelText({key: 'remote.enumerate.copyrightApplication', text: '版权登记'}),
        businessType: '5',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 40
    },
    COPYRIGHT_OTHERS: {
        value: '10052',
        label: getLabelText({key: 'remote.enumerate.copyrightOthers', text: '版权其他'}),
        businessType: '5',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 41,
        tag: getLabelText({ key: 'remote.common.other', text: '其他' })
    },
    POWER_OF_ATTORNEY_NOTARIZATION: {
        value: '10053',
        label: getLabelText({key: 'remote.enumerate.powerOfAttorneyNotarization', text: '商标文件商事认证'}),
        businessType: '6',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameNotarized', text: '已公证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameNotarization', text: '公证文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameNotarization', text: '公证文件'}),
        ippSort: 42
    },
    POWER_OF_ATTORNEY_AUTHENTICATION: {
        value: '10054',
        label: getLabelText({key: 'remote.enumerate.powerOfAttorneyAuthentication', text: '商标文件领事认证'}),
        businessType: '6',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAuthenticated', text: '已认证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameAuthentication', text: '认证文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameAuthentication', text: '认证文件'}),
        ippSort: 43
    },
    SC_SERVICE_AUTHORIZED: {
        value: '10055',
        label: getLabelText({key: 'remote.enumerate.scServiceAuthorized', text: '审查意见答复官费'})
    },
    MAKE_UP_THE_DIFFERENCE_SERVICE: {
        value: '11001',
        label: getLabelText({key: 'remote.enumerate.makeUpTheDifferenceService', text: '补差价'}),
        serviceType: '11001',
        serverType: '11001',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeDifPrice', text: 'DIF_PRICE'}),
        vatIncrement: 1,
        serverName: getLabelText({key: 'remote.enumerate.makeUpTheDifferenceService', text: '补差价'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.makeUpTheDifferenceService', text: '补差价'}),
        include: 99
    },
    CUSTOM_UNIVERSAL: {
        value: '11000',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeCustomOrderGeneral', text: '自定义订单通用'}),
        serviceType: '11000',
        serverType: '11000',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeCustomOrderGeneral',
            text: '自定义订单通用'
        }),
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeCustomOrderGeneral', text: '自定义订单通用'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeCustomOrderGeneral',
            text: '自定义订单通用'
        }),
        include: 99,
        inAdmin: 1
    },
    VAT_UNIVERSAL: {
        value: '11002',
        label: getLabelText({key: 'remote.enumerate.vatUniversal', text: 'VAT通用服务类型'}),
        serviceType: '11002',
        serverType: '11002',
        belongingToType: getLabelText({key: 'remote.enumerate.vatUniversal', text: 'VAT通用服务类型'}),
        serverName: getLabelText({key: 'remote.enumerate.vatUniversal', text: 'VAT通用服务类型'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.vatUniversal', text: 'VAT通用服务类型'}),
        include: 99,
        inAdmin: 1
    },
    EPR_UNIVERSAL: {
        value: '11003',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeEprGeneralServiceType', text: 'EPR通用服务类型'}),
        serviceType: '11003',
        serverType: '11003',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeEprGeneralServiceType',
            text: 'EPR通用服务类型'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeEprGeneralServiceType',
            text: 'EPR通用服务类型'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeEprGeneralServiceType',
            text: 'EPR通用服务类型'
        }),
        include: 99,
        inAdmin: 1
    },
    RSP_UNIVERSAL: {
        value: '11004',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeRspGeneralServiceType', text: 'RSP通用服务类型'}),
        serviceType: '11004',
        serverType: '11004',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeRspGeneralServiceType',
            text: 'RSP通用服务类型'
        }),
        serverName: getLabelText({
            key: 'remote.enumerate.belongingToTypeRspGeneralServiceType',
            text: 'RSP通用服务类型'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeRspGeneralServiceType',
            text: 'RSP通用服务类型'
        }),
        include: 99,
        inAdmin: 1
    },
    OC_UNIVERSAL: {
        value: '11005',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeOcGeneralServiceType', text: 'OC通用服务类型'}),
        serviceType: '11005',
        serverType: '11005',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeOcGeneralServiceType',
            text: 'OC通用服务类型'
        }),
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeOcGeneralServiceType', text: 'OC通用服务类型'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeOcGeneralServiceType',
            text: 'OC通用服务类型'
        }),
        include: 99,
        inAdmin: 1
    },
    CI_UNIVERSAL: {
        value: '11006',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeCIUniversalServiceType', text: 'CI通用服务类型'}),
        serviceType: '11006',
        serverType: '11006',
        belongingToType: getLabelText({
            key: 'remote.enumerate.belongingToTypeCIUniversalServiceType',
            text: 'CI通用服务类型'
        }),
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeCIUniversalServiceType', text: 'CI通用服务类型'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.belongingToTypeCIUniversalServiceType',
            text: 'CI通用服务类型'
        }),
        include: 99,
        inAdmin: 1
    },
    VOUCHER_PRODUCT: {
        value: '12000',
        label: getLabelText({key: 'remote.enumerate.belongingToTypeCouponPackage', text: '券包'}),
        serviceType: '12000',
        serverType: '12000',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeCouponPackage', text: '券包'}),
        serverName: getLabelText({key: 'remote.enumerate.belongingToTypeCouponPackage', text: '券包'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.belongingToTypeCouponPackage', text: '券包'}),
        include: 99,
        inAdmin: 1
    },
    COMPANY_REGISTER: {
        value: '20001',
        serverName: getLabelText({key: 'remote.enumerate.companyRegister', text: '公司注册'}),
        routersValue: 'XMIncorporation',
        serviceType: '20001',
        serverType: '20001',
        label: getLabelText({key: 'remote.enumerate.companyRegister', text: '公司注册'}),
        include: 5
    },
    OPEN_BANK_ACCOUNT: {
        value: '20002',
        serverName: getLabelText({key: 'remote.enumerate.openBankAccount', text: '银行开户'}),
        routersValue: 'XMBankAccount',
        serviceType: '20002',
        serverType: '20002',
        label: getLabelText({key: 'remote.enumerate.openBankAccount', text: '银行开户'}),
        include: 5
    },
    ACCOUNT_AUDIT_FLOW: {
        value: '20003',
        serverName: getLabelText({key: 'remote.enumerate.accountAuditFlow', text: '做账审计'}),
        routersValue: 'XMAccountingServicesTab',
        serviceType: '20003',
        serverType: '20003',
        label: getLabelText({key: 'remote.enumerate.accountAuditFlow', text: '做账审计'}),
        include: 5
    },
    COMPANY_ANNUAL_REVIEW: {
        value: '20004',
        serverName: getLabelText({key: 'remote.enumerate.companyAnnualReview', text: '公司年审续费'}),
        routersValue: 'XMSecretaryServicesTab',
        serviceType: '20004',
        serverType: '20004',
        label: getLabelText({key: 'remote.enumerate.companyAnnualReview', text: '公司年审续费'}),
        isRenewal: true,
        include: 5
    },
    // COMPANY_CONVERSION: {
    //   value: '20005',
    //   label: getLabelText({ key: 'remote.enumerate.companyConversion', text: '公司变更' }),
    //   include: 5
    // },
    COMPANY_DEREGISTER: {
        value: '20006',
        serverName: getLabelText({key: 'remote.enumerate.companyDeregister', text: '公司注销'}),
        routersValue: 'XMSecretaryServicesTab',
        serviceType: '20006',
        serverType: '20006',
        label: getLabelText({key: 'remote.enumerate.companyDeregister', text: '公司注销'}),
        include: 5
    },
    COMPANY_ANNUAL_REVIEW_TRANSFER: {
        value: '20007',
        serverName: getLabelText({key: 'remote.enumerate.companyAnnualReviewTransfer', text: '公司转年审'}),
        routersValue: 'XMSecretaryServicesTab',
        serviceType: '20007',
        serverType: '20007',
        label: getLabelText({key: 'remote.enumerate.companyAnnualReviewTransfer', text: '公司转年审'}),
        include: 5
    },
    COMPLIANCE_CONSULTATION: {
        value: '20013',
        serverName: getLabelText({key: 'remote.common.complianceConsultation', text: '合规咨询'}),
        routersValue: 'XMComplianceConsultation',
        serviceType: '20013',
        serverType: '20013',
        label: getLabelText({key: 'remote.common.complianceConsultation', text: '合规咨询'}),
        include: 5
    },
    PROXY_PAYMENT: {
        value: '20009',
        serverName: getLabelText({key: 'remote.enumerate.proxyPayment', text: '代缴代付'}),
        serviceType: '20009',
        serverType: '20009',
        label: getLabelText({key: 'remote.enumerate.proxyPayment', text: '代缴代付'}),
        include: 5
    },
    VALUE_ADDED_SERVICES: {
        value: '20011',
        serverName: getLabelText({key: 'remote.enumerate.valueAddedServices', text: '增值服务'}),
        routersValue: 'XMSecretaryServicesTab',
        serviceType: '20011',
        serverType: '20011',
        label: getLabelText({key: 'remote.enumerate.valueAddedServices', text: '增值服务'}),
        include: 5
    },
    VALUE_ADDED_SERVICES_RENEWAL: {
        value: '21011',
        serverName: `${getLabelText({key: 'remote.enumerate.valueAddedServices', text: '增值服务'})}${getLabelText({key: 'remote.common.renewal', text: '续费'})}`,
        routersValue: 'XMSecretaryServicesTab',
        serviceType: '21011',
        serverType: '21011',
        label: `${getLabelText({key: 'remote.enumerate.valueAddedServices', text: '增值服务'})}${getLabelText({key: 'remote.common.renewal', text: '续费'})}`,
        isRenewal: true,
        include: 5
    },
    ACCOUNT_AUDIT_FLOW_REVIEW: {
        value: '21003',
        serverName: getLabelText({key: 'remote.enumerate.accountAuditFlowReview', text: '做账审计续费'}),
        routersValue: 'XMAccountingServicesTab',
        serviceType: '21003',
        serverType: '21003',
        label: getLabelText({key: 'remote.enumerate.accountAuditFlowReview', text: '做账审计续费'}),
        isRenewal: true,
        include: 5
    },
    COMPLIANCE_CONSULTATION_RENEWAL: {
        value: '21013',
        routersValue: 'XMComplianceConsultation',
        serverName: getLabelText({key: 'remote.common.complianceConsultationRenewal', text: '合规咨询续费'}),
        serviceType: '21013',
        serverType: '21013',
        label: getLabelText({key: 'remote.common.complianceConsultationRenewal', text: '合规咨询续费'}),
        isRenewal: true,
        include: 5
    },
    CUSTOMS_INTELLECTUAL_PROPERTY_FILING: {
        value: '10061',
        label: getLabelText({key: 'remote.enumerate.customsIntellectualPropertyFiling', text: '海关知识产权备案'}),
        businessType: '7',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameApproved', text: '已核准'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameApprovalProof', text: '核准证明'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameApprovalProof', text: '核准证明'}),
        ippSort: 44
    },
    OA_REPLY: {
        value: '10062',
        label: getLabelText({key: 'remote.enumerate.oaReply', text: '商标审查意见答复'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 45,
        isRenewable: 1,
        hasCloseModule: 1
    },
    APPEARANCE_PATENT_FILING_AN_INVALID_APPLICATION: {
        value: '10057',
        label: getLabelText({
            key: 'remote.enumerate.appearancePatentFilingAnInvalidApplication',
            text: '外观设计无效申请'
        }),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 46,
        hasFinishModule: 1
    },
    PLASTIC_TAX_INCREMENT: {
        value: '141',
        label: getLabelText({key: 'remote.enumerate.plasticTaxIncrement', text: '塑料税增值服务'}),
        serviceType: '141',
        serverType: '141',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypePlasticTax', text: '塑料税'}),
        serverName: getLabelText({key: 'remote.enumerate.plasticTaxIncrement', text: '塑料税增值服务'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.plasticTaxIncrement', text: '塑料税增值服务'}),
        include: 1
    },
    PRODUCT_REGISTRATION_INCREMENT: {
        value: '252',
        label: getLabelText({key: 'remote.enumerate.productRegistrationIncrement', text: '产品注册增值服务'}),
        serviceType: '252',
        serverType: '252',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeProductRegistration', text: '产品注册'}),
        serverName: getLabelText({key: 'remote.enumerate.productRegistrationIncrement', text: '产品注册增值服务'}),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.productRegistrationIncrement',
            text: '产品注册增值服务'
        }),
        include: 7
    },
    PACKING_OFFICIAL_FEES: {
        value: '402',
        label: getLabelText({key: 'remote.enumerate.packingOfficialFees', text: '包装法官费'})
    },
    TEXTILE_OFFICIAL_FEES: {
        value: '415',
        label: getLabelText({key: 'remote.enumerate.textileOfficialFees', text: '纺织法官费'})
    },
    LZ_CLIMATEPARTNER: {
        value: '9000',
        label: getLabelText({key: 'remote.enumerate.lzClimatepartner', text: 'ClimatePartner认证'}),
        include: 6
    },
    LZ_CBAM: {
        value: '9018',
        label: getLabelText({key: 'remote.enumerate.serviceType9018', text: 'CBAM申报'}),
        include: 6
    },
    LZ_CBAM_RENEW: {
        value: '9019',
        label: getLabelText({key: 'remote.enumerate.serviceType9019', text: 'CBAM申报续费'}),
        include: 6
    },
    LZ_CARBONFREE: {
        value: '9001',
        label: getLabelText({key: 'remote.enumerate.carbonfreeCertification', text: 'Carbonfree认证'}),
        include: 6
    },
    LZ_EUDRCOMPLIANCE: {
    value: '9028',
    label: getLabelText({ key: 'remote.common.EUDRCompliance', text: 'EUDR合规' }),
    include: 6
  },
    LZ_EUDR_RENEW: {
        value: '9031',
        label: getLabelText({key: 'remote.enumerate.serviceType9031', text: 'EUDR合规续费'}),
        include: 6
    },
    LZ_CP_ONE_PRICE: {
        value: '9032',
        label: getLabelText({key: 'remote.enumerate.serviceType9032', text: 'CP一口价'}),
        include: 6
    },
    LZ_INTERNATIONAL_EPD: {
        value: '9002',
        label: getLabelText({key: 'remote.enumerate.lzInternationalEpd', text: '国际EPD'}),
        include: 6
    },
    LZ_CDP_CARBON_PROJECT_DISCLOSURE: {
        value: '9003',
        label: getLabelText({key: 'remote.enumerate.lzCdpCarbonProjectDisclosure', text: 'CDP碳项目披露'}),
        include: 6
    },
    LZ_SBTI_SCIENTIFIC_CARBON_TARGET: {
        value: '9004',
        label: getLabelText({key: 'remote.enumerate.lzSbtiScientificCarbonTarget', text: 'SBTI科学碳目标'}),
        include: 6
    },
    LZ_EU_CBAM: {
        value: '9005',
        label: getLabelText({key: 'remote.enumerate.lzEuCbam', text: '欧盟CBAM'}),
        include: 6
    },
    LZ_GRS_CERTIFICATION: {
        value: '9006',
        label: getLabelText({key: 'remote.enumerate.lzGrsCertification', text: 'GRS认证'}),
        include: 6
    },
    LZ_FSC_CERTIFICATION: {
        value: '9007',
        label: getLabelText({key: 'remote.enumerate.lzFscCertification', text: 'FSC认证'}),
        include: 6
    },
    LZ_OKEOTEX_CERTIFICATION: {
        value: '9008',
        label: getLabelText({key: 'remote.enumerate.lzOkeotexCertification', text: 'OEKO-TEX认证'}),
        include: 6
    },
    LZ_CP_ENTERPRISE_REGISTRATION_OFFICER_FEE: {
        value: '9009',
        label: getLabelText({
            key: 'remote.common.cpClimateFriendlyCertificationCorporateRegistrationFee',
            text: 'CP气候友好认证官费-企业注册费'
        }),
        include: 6
    },
    LZ_CP_PRODUCT_CERTIFICATION_OFFICER_FEE: {
        value: '9010',
        label: getLabelText({
            key: 'remote.common.cpClimateFriendlyCertificationProductCertificationFee',
            text: 'CP气候友好认证官费-产品核证费'
        }),
        include: 6
    },
    LZ_CP_CARBON_OFFSET_OFFICIAL_FEES: {
        value: '9011',
        label: getLabelText({
            key: 'remote.common.cpClimateFriendlyCertificationCarbonOffsetConsumptionFee',
            text: 'CP气候友好认证官费-碳汇抵消费'
        }),
        include: 6
    },
    LZ_CLIMATEPARTNER_ADD: {
        value: '9015',
        label: getLabelText({key: 'remote.enumerate.AdditionalClimatePartner', text: 'ClimatePartner认证追加'}),
        include: 6
    },
    LZ_CLIMATEPARTNER_RENEW: {
        value: '9016',
        label: getLabelText({key: 'remote.enumerate.serviceType9016', text: 'ClimateParner认证续费'}),
        include: 6
    },
    LZ_CLIMATEPARTNER_CERTIFICATE_RENEW: {
        value: '9017',
        label: getLabelText({key: 'remote.enumerate.serviceType9017', text: 'ClimateParner认证（证书更新）'}),
        include: 6
    },
    LZ_ISCC_PLUS_CERTIFICATION: {
        value: '9020',
        label: getLabelText({key: 'remote.enumerate.ISCCPLUSCertification', text: 'ISCC PLUS认证'}),
        include: 6
    },
    LZ_RCS_CERTIFICATION: {
        value: '9021',
        label: getLabelText({key: 'remote.enumerate.RCSCertification', text: 'RCS认证'}),
        include: 6
    },
    LZ_GOTS_CERTIFICATION: {
        value: '9022',
        label: getLabelText({key: 'remote.enumerate.GOTSCertification', text: 'GOTS认证'}),
        include: 6
    },
    LZ_LWG_CERTIFICATION: {
        value: '9023',
        label: getLabelText({key: 'remote.enumerate.LWGCertification', text: 'LWG认证'}),
        include: 6
    },
    LZ_USDAORGANIC_CERTIFICATION: {
        value: '9024',
        label: getLabelText({key: 'remote.enumerate.USDAorganicCertification', text: 'USDAorganic认证'}),
        include: 6
    },
    LZ_EWG_CERTIFICATION: {
        value: '9025',
        label: getLabelText({key: 'remote.enumerate.EWGCertification', text: 'EWG认证'}),
        include: 6
    },
    LZ_OCS_CERTIFICATION: {
    value: '9026',
    label: getLabelText({ key: 'remote.enumerate.OCSCertification', text: 'OCS认证' }),
    include: 6
  },
  LZ_EWG_OTHERSERVICES: {
    value: '9027',
    label: getLabelText({ key: 'remote.enumerate.otherServices', text: '其他服务' }),
    include: 6
  },
  LZ_CPF_CERTIFICATION: {
    value: '9029',
    label: getLabelText({ key: 'remote.enumerate.CPFCertification', text: 'CPF认证' }),
    include: 6
  },
  LZ_CPF_CERTIFICATION_RENEW: {
    value: '9030',
    label: getLabelText({ key: 'remote.enumerate.CPFCertificationRenewal', text: 'CPF认证续费' }),
    include: 6
  },
  LAWYERS_LETTER_REPLY: {
        value: '10058',
        label: getLabelText({key: 'remote.enumerate.lawyersLetterReply', text: '商标律师函答复'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 46,
        isRenewable: 1,
        hasCloseModule: 1
    },
    TRADEMARK_INTENT_USE_EVIDENCE_DELAY: {
        value: '10063',
        label: getLabelText({
            key: 'remote.enumerate.trademarkIntentUseEvidenceDelay',
            text: '商标意向申请使用证据递交延期'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 47,
        tag: getLabelText({key: 'remote.enumerate.extensionOfNOA', text: 'NOA延期'}),
        isRenewable: 1,
        hasCloseModule: 1
    },
    TRADEMARK_RENEWAL_OATH_SUBMISSION: {
        value: '10064',
        label: getLabelText({key: 'remote.enumerate.trademarkRenewalOathSubmission', text: '商标续展及宣誓'}),
        businessType: '9',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.common.receiveNotifications', text: '接收通知'}),
        closeFileName: getLabelText({key: 'remote.common.receiveNotifications', text: '接收通知'}),
        ippSort: 48,
        isRenewable: 1,
        hasFinishModule: 1
    },
    TRADEMARK_REVIVAL_APPLICATION_DELAY: {
        value: '10065',
        label: getLabelText({key: 'remote.enumerate.trademarkRevivalApplicationDelay', text: '商标复活申请及延期'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 49,
        tag: getLabelText({key: 'remote.enumerate.restorationOfExtension', text: '恢复延期'}),
        isRenewable: 1,
        hasCloseModule: 1
    },
    TRADEMARK_HOLDER_INFORMATION_CORRECTION: {
        value: '10066',
        label: getLabelText({key: 'remote.enumerate.trademarkHolderInformationCorrection', text: '商标持有人信息更正'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 50,
        isRenewable: 1,
        hasCloseModule: 1
    },
    TRADEMARK_OFFICIAL_DOCUMENT_COPY_APPLICATION: {
        value: '10067',
        label: getLabelText({
            key: 'remote.enumerate.trademarkOfficialDocumentCopyApplication',
            text: '商标官方文件副本申请'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 51,
        hasCloseModule: 1
    },
    TRADEMARK_SEARCH: {
        value: '10068',
        label: getLabelText({key: 'remote.enumerate.trademarkSearch', text: '商标检索'}),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 52,
        hasCloseModule: 1
    },
    APPEARANCE_DESIGN_INVALID_DEFENSE: {
        value: '10069',
        label: getLabelText({key: 'remote.enumerate.appearanceDesignInvalidDefense', text: '外观设计无效答辩'}),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 53,
        isRenewable: 1,
        hasCloseModule: 1
    },
    APPEARANCE_DESIGN_ACTIVE_CANCELLATION: {
        value: '10070',
        label: getLabelText({key: 'remote.enumerate.appearanceDesignActiveCancellation', text: '外观设计主动撤销'}),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 54,
        hasCloseModule: 1
    },
    APPEARANCE_HOLDER_INFORMATION_CORRECTION: {
        value: '10071',
        label: getLabelText({
            key: 'remote.enumerate.appearanceHolderInformationCorrection',
            text: '外观持有人信息更正'
        }),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 55,
        isRenewable: 1,
        hasCloseModule: 1
    },
    APPEARANCE_OFFICIAL_DOCUMENT_COPY_APPLICATION: {
        value: '10072',
        label: getLabelText({
            key: 'remote.enumerate.appearanceOfficialDocumentCopyApplication',
            text: '外观官方文件副本申请'
        }),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 56,
        hasCloseModule: 1
    },
    APPEARANCE_LAWYER_REPLY: {
        value: '10073',
        label: getLabelText({key: 'remote.enumerate.appearanceLawyerReply', text: '外观律师函答复'}),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 57,
        isRenewable: 1,
        hasCloseModule: 1
    },
    GF_DIFFERENCE: {
        value: '10059',
        label: getLabelText({key: 'remote.common.differenceOfficialPrice', text: '补差价官费'}),
    },
    TRADEMARK_DEFENSE_OTHER_REPLY: {
        value: '10074',
        label: getLabelText({
            key: 'remote.enumerate.trademarkExaminationOpinionResponseOthers',
            text: '商标审查意见答复（其他）'
        }),
        businessType: '1',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 58,
        tag: getLabelText({key: 'remote.enumerate.officeActionResponse', text: 'OA答复'}),
        isRenewable: 1,
        hasCloseModule: 1
    },
    APPEARANCE_ACTIVE_DISCLOSURE: {
        value: '10075',
        label: getLabelText({key: 'remote.enumerate.proactiveDisclosureServiceForDesigns', text: '外观主动披露服务'}),
        businessType: '4',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameAlreadyCertified', text: '已下证'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameIssuedCertificate', text: '下证证书'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCertificate', text: '证书'}),
        ippSort: 58,
        tag: getLabelText({key: 'remote.enumerate.disclosure', text: '披露'}),
        hasCloseModule: 1
    },
    FILING_SERVICE: {
        value: '10077',
        label: getLabelText({key: 'remote.common.filingService', text: '备案服务'})
    },
    //initiationConditions:admin商品配置发起条件
    VAT_OTHER_APPLICATIONS_SUPPLEMENTARY_INFORMATION: {
        value: '89',
        serverType: '89',
        label: getLabelText({
            key: 'remote.enumerate.VATOtherApplicationsSupplementaryInformation',
            text: 'VAT其他申请/补充资料'
        }),
        initiationConditions: true,
        serverDetailName: getLabelText({
            key: 'remote.enumerate.VATOtherApplicationsSupplementaryInformation',
            text: 'VAT其他申请/补充资料'
        }),
    },
    EPR_OTHER_APPLICATIONS_SUPPLEMENTARY_MATERIALS: {
        value: '90',
        label: getLabelText({
            key: 'remote.enumerate.EPROtherApplicationsSupplementaryMaterials',
            text: 'EPR其他申请/补充资料'
        }),
        initiationConditions: true
    },
    AUTH_OTHER_APPLICATIONS_SUPPLY_MATERIALS: {
        value: '91',
        serverType: '91',
        label: getLabelText({
            key: 'remote.enumerate.authOtherApplicationsSupplyMaterials',
            text: '授权代表其他申请/补充资料'
        }),
        initiationConditions: true,
        serverDetailName: getLabelText({
            key: 'remote.enumerate.authOtherApplicationsSupplyMaterials',
            text: '授权代表其他申请/补充资料'
        })
    },
    IOSS_SUPPLEMENTARY_DECLARATION: {
        value: '180',
        label: getLabelText({key: 'remote.enumerate.serviceType180', text: 'IOSS补申报'}),
        serviceType: '180',
        serverType: '180',
        serverName: getLabelText({key: 'remote.enumerate.serviceType180', text: 'IOSS补申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.serviceType180', text: 'IOSS补申报'}),
        include: 0,
        vatIncrement: 1,
    },
    JCT_SUPPLEMENTARY_APPLICATION: {
        value: '19',
        label: getLabelText({key: 'remote.enumerate.jctPatchDeclarationServerDetailName', text: 'JCT补申报'}),
        serviceType: '19',
        serverType: '19',
        belongingToType: getLabelText({key: 'remote.enumerate.JCT', text: 'JCT'}),
        serverName: getLabelText({key: 'remote.enumerate.jctPatchDeclarationServerDetailName', text: 'JCT补申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.jctPatchDeclarationServerDetailName', text: 'JCT补申报'}),
        include: 0,
        vatIncrement: 1,
    },
    RFC_SUPPLEMENTARY_DECLARATION: {
        value: '410',
        label: getLabelText({key: 'remote.enumerate.rfcPatchDeclarationServerDetailName', text: 'RFC补申报'}),
        serviceType: '410',
        serverType: '410',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeRfc', text: 'RFC'}),
        serverName: getLabelText({key: 'remote.enumerate.rfcPatchDeclarationServerDetailName', text: 'RFC补申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.rfcPatchDeclarationServerDetailName', text: 'RFC补申报'}),
        include: 0,
        vatIncrement: 1,
    },
    VOCE_SUPPLEMENTARY_DECLARATION: {
        value: '77',
        label: getLabelText({key: 'remote.enumerate.voecPatchDeclarationServerDetailName', text: 'VOEC补申报'}),
        serviceType: '77',
        serverType: '77',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeVoec', text: 'VOEC'}),
        serverName: getLabelText({key: 'remote.enumerate.voecPatchDeclarationServerDetailName', text: 'VOEC补申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.voecPatchDeclarationServerDetailName', text: 'VOEC补申报'}),
        include: 0,
        vatIncrement: 1,
    },
    OSS_SUPPLEMENTARY_DECLARATION: {
        value: '76',
        label: getLabelText({key: 'remote.enumerate.ossPatchDeclarationServerDetailName', text: 'OSS补申报'}),
        serviceType: '76',
        serverType: '76',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeOss', text: 'OSS'}),
        serverName: getLabelText({key: 'remote.enumerate.ossPatchDeclarationServerDetailName', text: 'OSS补申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.ossPatchDeclarationServerDetailName', text: 'OSS补申报'}),
        include: 0,
        vatIncrement: 1,
    },
    GST_SUPPLEMENTARY_DECLARATION: {
        value: '430',
        label: getLabelText({key: 'remote.enumerate.gstPatchDeclarationServerDetailName', text: 'GST补申报'}),
        serviceType: '430',
        serverType: '430',
        belongingToType: getLabelText({key: 'remote.enumerate.belongingToTypeGst', text: 'GST'}),
        serverName: getLabelText({key: 'remote.enumerate.gstPatchDeclarationServerDetailName', text: 'GST补申报'}),
        serverDetailName: getLabelText({key: 'remote.enumerate.gstPatchDeclarationServerDetailName', text: 'GST补申报'}),
        include: 0,
        vatIncrement: 1,
    },
    VAT_COMPLIANCE: {
        value: '351',
        serverType: '351',
        label: getLabelText({
            key: 'remote.enumerate.vatCompliance',
            text: 'VAT合规服务费'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.vatCompliance',
            text: 'VAT合规服务费'
        }),
        include: 0,
        vatIncrement: 1,
    },
    RSP_COMPLIANCE: {
        value: '352',
        serverType: '352',
        label: getLabelText({
            key: 'remote.enumerate.rspCompliance',
            text: '授权代表合规服务费'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.rspCompliance',
            text: '授权代表合规服务费'
        }),
        include: 2,
    },
    VAT_COMPLIANCE_MARGIN: {
        value: '353',
        serverType: '353',
        label: getLabelText({
            key: 'remote.enumerate.vatComplianceMargin',
            text: 'VAT合规保证金'
        }),
        adminCreateStatus: true,
        serverDetailName: getLabelText({
            key: 'remote.enumerate.vatComplianceMargin',
            text: 'VAT合规保证金'
        }),
        // include: 0,
        vatIncrement: 1,
        inAdmin: 1,
    },
    RSP_COMPLIANCE_MARGIN: {
        value: '354',
        serverType: '354',
        label: getLabelText({
            key: 'remote.enumerate.rspComplianceMargin',
            text: '授权代表合规保证金'
        }),
        serverDetailName: getLabelText({
            key: 'remote.enumerate.rspComplianceMargin',
            text: '授权代表合规保证金'
        }),
        adminCreateStatus: true,
        // include: 2,
        inAdmin: 1,
    },
    TRO_PROSECUTION: {
        value: '10081',
        label: getLabelText({key: 'remote.common.troFiling', text: 'TRO起诉'}),
        businessType: '8',
        isNextReceipt: false,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 80,
        hasFinishModule: 1
    },
    TRO_RESPONSE: {
        value: '10082',
        label: getLabelText({key: 'remote.common.troResponse', text: 'TRO应诉'}),
        businessType: '8',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 81,
        hasFinishModule: 1
    },
    TRO_SETTLEMENT: {
        value: '10083',
        label: getLabelText({key: 'remote.common.troSettlement', text: 'TRO和解'}),
        businessType: '8',
        isNextReceipt: true,
        closeNodeName: getLabelText({key: 'remote.enumerate.closeNodeNameCompleted', text: '已完结'}),
        finishFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        closeFileName: getLabelText({key: 'remote.enumerate.finishFileNameCompletionFile', text: '完结文件'}),
        ippSort: 82,
        hasFinishModule: 1
    },
})
//带有serviceType为目前所有ost服务资料集合
const enumData = COMMON_SERVICE_TYPE.enumData
const VAT_SERVICE_TYPE = COMMON_SERVICE_TYPE.getEnumFilter(Object.keys(enumData).filter((k) => !enumData[k].serverDetailName))
const XM_SERVICE_TYPE = COMMON_SERVICE_TYPE.getEnumFilter(Object.keys(enumData).filter((k) => enumData[k].include !== 5))
const LZ_SERVICE_TYPE = COMMON_SERVICE_TYPE.getEnumFilter(Object.keys(enumData).filter((k) => enumData[k].include !== 6))
const MAIN_SERVICE_TYPE = COMMON_SERVICE_TYPE.getEnumFilter(Object.keys(enumData).filter((k) => enumData[k].isMainService != 1))

//是否电池法(解决研发中文判断问题)
function isBattery(serviceType) {
    return [
        COMMON_SERVICE_TYPE.BATTERY_REGISTRATION_DECLARATION,
        COMMON_SERVICE_TYPE.BATTERY_RENEW,
        COMMON_SERVICE_TYPE.BATTERY_ADD_BRAND,
        COMMON_SERVICE_TYPE.BATTERY_ADD_WEIGHT,
        COMMON_SERVICE_TYPE.BATTERY_INCREMENT,
        COMMON_SERVICE_TYPE.BATTERY_CANCELLATION,
        COMMON_SERVICE_TYPE.BATTERY_TRANSFORM_DECLARATION
    ].includes(String(serviceType))
}

//WEEE类型
function isWeee(serviceType) {
    return [
        COMMON_SERVICE_TYPE.WEEE_REGISTRATION_DECLARATION,
        COMMON_SERVICE_TYPE.WEEE_RENEW,
        COMMON_SERVICE_TYPE.WEEE_ADD_BRAND,
        COMMON_SERVICE_TYPE.WEEE_INCREMENT,
        COMMON_SERVICE_TYPE.WEEE_CANCELLATION_SERVCIE,
        COMMON_SERVICE_TYPE.WEEE_TRANSFORM_DECLARATION
    ].includes(String(serviceType))
}

export {
    isBattery,
    isWeee,
    COMMON_SERVICE_TYPE,
    //ost服务类型
    VAT_SERVICE_TYPE,
    // 小贸服务类型
    XM_SERVICE_TYPE,
    // 绿舟服务类型
    LZ_SERVICE_TYPE,
    // 主服务
    MAIN_SERVICE_TYPE
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/commonServiceType.js